import "core-js/modules/es6.array.from";
import "core-js/modules/es6.string.link";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.date.now";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.reflect.apply";
import "core-js/modules/es6.array.last-index-of";
import "core-js/modules/es6.reflect.delete-property";
import "core-js/modules/es6.reflect.has";
import "core-js/modules/es6.reflect.define-property";
import "core-js/modules/es6.reflect.set";
import "core-js/modules/es6.reflect.get-own-property-descriptor";
import "core-js/modules/es6.map";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.reflect.get";
import "core-js/modules/es6.weak-map";
import "core-js/modules/es6.object.is";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.string.repeat";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";
import { Builder, builder, Subscription, BehaviorSubject } from "@builder.io/sdk";
export { Builder, builder } from "@builder.io/sdk";
import { jsx, ClassNames } from "@emotion/core";
import React from "react";
import ReactDOM from "react-dom";
import hash from "hash-sum";

var version = "1.1.11",
    _a;

"undefined" != typeof window && (null === (_a = window.parent) || void 0 === _a || _a.postMessage({
  type: "builder.isReactSdk",
  data: {
    value: !0,
    supportsPatchUpdates: "v2",
    priorVersion: version
  }
}, "*"))
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
;

var _extendStatics = function extendStatics(e, t) {
  return (_extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (e, t) {
    e.__proto__ = t;
  } || function (e, t) {
    for (var n in t) {
      t.hasOwnProperty(n) && (e[n] = t[n]);
    }
  })(e, t);
};

function __extends(e, t) {
  function n() {
    this.constructor = e;
  }

  _extendStatics(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
}

var _assign = function __assign() {
  return (_assign = Object.assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      for (var i in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
      }
    }

    return e;
  }).apply(this, arguments);
};

function __decorate(e, t, n, r) {
  var i,
      o = arguments.length,
      s = o < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
  if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t, n, r);else for (var a = e.length - 1; a >= 0; a--) {
    (i = e[a]) && (s = (o < 3 ? i(s) : o > 3 ? i(t, n, s) : i(t, n)) || s);
  }
  return o > 3 && s && Object.defineProperty(t, n, s), s;
}

function __metadata(e, t) {
  if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
}

function __awaiter(e, t, n, r) {
  return new (n || (n = Promise))(function (i, o) {
    function s(e) {
      try {
        l(r.next(e));
      } catch (e) {
        o(e);
      }
    }

    function a(e) {
      try {
        l(r["throw"](e));
      } catch (e) {
        o(e);
      }
    }

    function l(e) {
      e.done ? i(e.value) : new n(function (t) {
        t(e.value);
      }).then(s, a);
    }

    l((r = r.apply(e, t || [])).next());
  });
}

function __generator(e, t) {
  var n,
      r,
      i,
      o,
      s = {
    label: 0,
    sent: function sent() {
      if (1 & i[0]) throw i[1];
      return i[1];
    },
    trys: [],
    ops: []
  };
  return o = {
    next: a(0),
    "throw": a(1),
    "return": a(2)
  }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
    return this;
  }), o;

  function a(o) {
    return function (a) {
      return function (o) {
        if (n) throw new TypeError("Generator is already executing.");

        for (; s;) {
          try {
            if (n = 1, r && (i = 2 & o[0] ? r["return"] : o[0] ? r["throw"] || ((i = r["return"]) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;

            switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
              case 0:
              case 1:
                i = o;
                break;

              case 4:
                return s.label++, {
                  value: o[1],
                  done: !1
                };

              case 5:
                s.label++, r = o[1], o = [0];
                continue;

              case 7:
                o = s.ops.pop(), s.trys.pop();
                continue;

              default:
                if (!(i = (i = s.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                  s = 0;
                  continue;
                }

                if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                  s.label = o[1];
                  break;
                }

                if (6 === o[0] && s.label < i[1]) {
                  s.label = i[1], i = o;
                  break;
                }

                if (i && s.label < i[2]) {
                  s.label = i[2], s.ops.push(o);
                  break;
                }

                i[2] && s.ops.pop(), s.trys.pop();
                continue;
            }

            o = t.call(e, s);
          } catch (e) {
            o = [6, e], r = 0;
          } finally {
            n = i = 0;
          }
        }

        if (5 & o[0]) throw o[1];
        return {
          value: o[0] ? o[1] : void 0,
          done: !0
        };
      }([o, a]);
    };
  }
}

function __spreadArrays() {
  for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
    e += arguments[t].length;
  }

  var r = Array(e),
      i = 0;

  for (t = 0; t < n; t++) {
    for (var o = arguments[t], s = 0, a = o.length; s < a; s++, i++) {
      r[i] = o[s];
    }
  }

  return r;
}

var sizeNames = ["xsmall", "small", "medium", "large"],
    sizes = {
  xsmall: {
    min: 0,
    "default": 0,
    max: 0
  },
  small: {
    min: 320,
    "default": 321,
    max: 640
  },
  medium: {
    min: 641,
    "default": 642,
    max: 991
  },
  large: {
    min: 990,
    "default": 991,
    max: 1200
  },
  getWidthForSize: function getWidthForSize(e) {
    return this[e]["default"];
  },
  getSizeForWidth: function getSizeForWidth(e) {
    for (var t = 0, n = sizeNames; t < n.length; t++) {
      var r = n[t];
      if (e <= this[r].max) return r;
    }

    return "large";
  }
},
    set = function set(e, t, n) {
  if (Object(e) !== e) return e;
  var r = Array.isArray(t) ? t : t.toString().match(/[^.[\]]+/g);
  return r.slice(0, -1).reduce(function (e, t, n) {
    return Object(e[t]) === e[t] ? e[t] : e[t] = Math.abs(Number(r[n + 1])) >> 0 == +r[n + 1] ? [] : {};
  }, e)[r[r.length - 1]] = n, e;
},
    safeDynamicRequire = Builder.isServer ? eval("require") : function () {
  return null;
},
    fnCache = {},
    api = function api(e) {
  return builder;
};

function stringToFunction(e, t, n, r) {
  if (void 0 === t && (t = !0), !e || !e.trim()) return function () {};
  var i = e + ":" + t;
  if (fnCache[i]) return fnCache[i];

  var o = t && !(e.includes(";") || e.includes(" return ") || e.trim().startsWith("return ")) || e.trim().startsWith("builder.run"),
      s = function s() {};

  e = e.replace(/builder\s*\.\s*use[a-zA-Z]*\(/g, "return(").replace(/builder\s*\.\s*set([a-zA-Z]+)To\(/g, function (e, t) {
    return 'builder.set("' + (t[0].toLowerCase() + t.substring(1)) + '",';
  }).replace(/builder\s*\.\s*get([a-zA-Z]+)\s*\(\s*\)/g, function (e, t) {
    return "state." + (t[0].toLowerCase() + t.substring(1));
  });

  try {
    Builder.isBrowser && (s = new Function("state", "event", "block", "builder", "Device", "update", "Builder", "context", "\n          var names = [\n            'state',\n            'event',\n            'block',\n            'builder',\n            'Device',\n            'update',\n            'Builder',\n            'context'\n          ];\n          var rootState = state;\n          if (typeof Proxy !== 'undefined') {\n            rootState = new Proxy(rootState, {\n              set: function () {\n                return false;\n              },\n              get: function (target, key) {\n                if (names.includes(key)) {\n                  return undefined;\n                }\n                return target[key];\n              }\n            });\n          }\n          /* Alias */\n          var ctx = context;\n          with (rootState) {\n            " + (o ? "return (" + e + ");" : e) + ";\n          }\n        "));
  } catch (t) {
    n && n.push(t);
    var a = t && t.message;
    a && "string" == typeof a && r && -1 === r.indexOf(a) && r.push(a), Builder.isBrowser && console.warn("Function compile error in " + e, t);
  }

  return fnCache[i] = function () {
    for (var t = [], r = 0; r < arguments.length; r++) {
      t[r] = arguments[r];
    }

    try {
      if (Builder.isBrowser) return s.apply(void 0, t);
      var i = safeDynamicRequire("vm2").VM,
          o = t[0],
          a = t[1];
      return new i({
        timeout: 100,
        sandbox: _assign(_assign(_assign(_assign({}, o), {
          state: o
        }), {
          builder: api
        }), {
          event: a
        })
      }).run(e.replace(/(^|;)return /, "$1"));
    } catch (t) {
      Builder.isBrowser ? console.warn("Builder custom code error:", t.message || t, "in", e, t.stack || t) : process.env.DEBUG && console.debug("Builder custom code error:", t.message || t, "in", e, t.stack || t), n && n.push(t);
    }
  };
}

var isPromise = function isPromise(e) {
  return "function" == typeof e.then;
},
    isRequestInfo = function isRequestInfo(e) {
  return !isPromise(e);
},
    BuilderAsyncRequestsContext = React.createContext({
  requests: [],
  errors: [],
  logs: []
}),
    BuilderStoreContext = React.createContext({
  state: {},
  rootState: {},
  content: {},
  context: {},
  update: function update(e) {
    return null;
  }
}),
    applyPatchWithMinimalMutationChain = function applyPatchWithMinimalMutationChain(e, t, n) {
  if (void 0 === n && (n = !0), Object(e) !== e) return e;
  var r = t.path,
      i = t.op,
      o = t.value,
      s = r.split(/\//);
  "" === s[0] && s.shift();

  for (var a = n ? e : _assign({}, e), l = a, u = 0; u < s.length; u++) {
    var p = u === s.length - 1,
        d = s[u];

    if (p) {
      if ("replace" === i) l[d] = o;else if ("add" === i) {
        var c = Number(d);
        Array.isArray(l) ? "-" === d ? l.push(o) : l.splice(c, 0, o) : l[d] = o;
      } else if ("remove" === i) {
        c = Number(d);
        Array.isArray(l) ? l.splice(c, 1) : delete l[d];
      }
    } else {
      var m = s[u + 1],
          h = Object(l[d]) === l[d] ? l[d] : String(Number(m)) === m ? [] : {};
      l = l[d] = Array.isArray(h) ? __spreadArrays(h) : _assign({}, h);
    }
  }

  return a;
},
    htmlEscape = function htmlEscape(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
},
    blockToHtmlString = function blockToHtmlString(e) {
  var t, n;
  return ("<" + htmlEscape(e.tagName || "div") + ' \n    class="builder-block ' + e.id + " " + (e["class"] || "") + '"\n    builder-id="' + e.id + '"\n  ' + Object.keys(e.properties || {}).map(function (t) {
    return htmlEscape(t) + '="' + htmlEscape(e.properties[t]) + '"';
  }).join(" ") + "\n  >" + ("Text" === (null === (n = null === (t = e) || void 0 === t ? void 0 : t.component) || void 0 === n ? void 0 : n.name) ? e.component.options.text : e.children ? e.children.map(function (e) {
    return blockToHtmlString(e);
  }).join("") : "") + "</" + (e.tagName || "div") + ">").replace(/\s+/g, " ");
},
    Link = function Link(e) {
  return React.createElement(BuilderStoreContext.Consumer, null, function (t) {
    return t.renderLink ? t.renderLink(e) : React.createElement("a", _assign({}, e));
  });
},
    camelCaseToKebabCase = function camelCaseToKebabCase(e) {
  return e ? e.replace(/([A-Z])/g, function (e) {
    return "-" + e[0].toLowerCase();
  }) : "";
},
    Device = {
  desktop: 0,
  tablet: 1,
  mobile: 2
},
    blocksMap = {},
    voidElements = new Set(["area", "base", "br", "col", "embed", "hr", "img", "input", "link", "meta", "param", "source", "track", "wbr"]);

function pick(e, t) {
  return t.reduce(function (t, n) {
    return e && e.hasOwnProperty(n) && (t[n] = e[n]), t;
  }, {});
}

var last = function last(e) {
  return e[e.length - 1];
};

function omit(e, t) {
  for (var n = Object.assign({}, e), r = 0, i = t; r < i.length; r++) {
    delete n[i[r]];
  }

  return n;
}

var cssCase = function cssCase(e) {
  if (!e) return e;
  var t = camelCaseToKebabCase(e);
  return e[0] === e[0].toUpperCase() && (t = "-" + t), t;
},
    fastClone = function fastClone(e) {
  return JSON.parse(JSON.stringify(e));
};

function mapToCss(e, t, n) {
  return void 0 === t && (t = 2), void 0 === n && (n = !1), Object.keys(e).reduce(function (r, i) {
    var o = e[i];
    return "string" != typeof o ? r : r + (o && o.trim() ? "\n" + " ".repeat(t) + cssCase(i) + ": " + o + (n ? " !important" : "") + ";" : "");
  }, "");
}

function capitalize(e) {
  if (e) return e[0].toUpperCase() + e.slice(1);
}

var BuilderBlock = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.state = {
      hasError: !1,
      updates: 0
    }, t.privateState = {
      state: {},
      rootState: {},
      context: {},
      update: function update() {}
    }, t.onWindowMessage = function (e) {
      var n = e.data;
      if (n) switch (n.type) {
        case "builder.selectionChange":
          if (!(o = n.data)) break;
          var r = o.selection,
              i = t.block && t.block.id;
          i && Array.isArray(r) && r.indexOf(i) > -1 && setTimeout(function () {
            window.$block = t, window.$blocks || (window.$blocks = []), window.$blocks.push(t);
          });
          break;

        case "builder.patchUpdates":
          var o;
          if (!(o = n.data) || !o.data) break;
          var s = o.data[t.block.id];
          if (!s) return;
          location.href.includes("builder.debug=true") && t.eval("debugger");

          for (var a = _assign({}, t.block), l = 0, u = s; l < u.length; l++) {
            var p = u[l];
            applyPatchWithMinimalMutationChain(a, p);
          }

          blocksMap[t.props.block.id] = a, t.setState({
            updates: t.state.updates + 1
          });
      }
    }, t;
  }

  return __extends(t, e), t.getDerivedStateFromError = function (e) {
    return {
      hasError: !0
    };
  }, t.prototype.componentDidCatch = function (e, t) {
    console.error("Builder block error:", e, t);
  }, t.prototype.stringToFunction = function (e, t) {
    return void 0 === t && (t = !0), stringToFunction(e, t, this._errors, this._logs);
  }, Object.defineProperty(t.prototype, "block", {
    get: function get() {
      return blocksMap[this.props.block.id] || this.props.block;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t.prototype, "styles", {
    get: function get() {
      var e,
          t = this.props.size,
          n = this.block,
          r = [],
          i = sizeNames.indexOf(t || "large");
      if (n.responsiveStyles) for (var o = i; o < sizeNames.length; o += 1) {
        var s = sizeNames[o];
        n.responsiveStyles[s] && r.push(n.responsiveStyles[s]);
      }

      if (!!this.privateState.state.isServer) {
        var a = n.animations && n.animations[0],
            l = a && a.steps && a.steps[0],
            u = l && l.styles;
        u && (e = u);
      }

      return Object.assign.apply(Object, __spreadArrays([{}], r.reverse(), [e]));
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t.prototype, "emotionCss", {
    get: function get() {
      var e,
          t,
          n,
          r = this.block;

      if (Builder.isServer) {
        var i = r.animations && r.animations[0];

        if (i && "hover" !== i.trigger) {
          var o = i && i.steps && i.steps[0],
              s = o && o.styles;
          s && (n = s);
        }
      }

      var a = sizeNames.slice().reverse(),
          l = this.block,
          u = {};
      if (l.responsiveStyles) for (var p = 0, d = a; p < d.length; p++) {
        var c = d[p];
        "large" === c ? this.props.emailMode || (u["&.builder-block"] = Object.assign({}, l.responsiveStyles[c], n)) : u["@media only screen and (max-width: " + sizes[c].max + "px)"] = {
          "&.builder-block": l.responsiveStyles[c]
        };
      }
      var m = r.animations && r.animations.find(function (e) {
        return "hover" === e.trigger;
      });
      return m && (u[":hover"] = (null === (t = null === (e = m.steps) || void 0 === e ? void 0 : e[1]) || void 0 === t ? void 0 : t.styles) || {}, u.transition = "all " + m.duration + "s " + camelCaseToKebabCase(m.easing), m.delay && (u.transitionDelay = m.delay + "s")), u;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t.prototype, "css", {
    get: function get() {
      var e = this.block,
          t = _assign({}, e.responsiveStyles && e.responsiveStyles.large),
          n = this.props.emailMode ? "" : ".builder-block." + e.id + " {" + mapToCss(t) + "}",
          r = sizeNames.slice().reverse();

      if (e.responsiveStyles) for (var i = 0, o = r; i < o.length; i++) {
        var s = o[i];

        if ((!this.props.emailMode || "large" !== s) && "large" !== s && "xsmall" !== s && e.responsiveStyles[s] && Object.keys(e.responsiveStyles[s]).length) {
          var a = ["display", "width", "verticalAlign"],
              l = e.responsiveStyles[s],
              u = this.props.emailMode && pick(l, a);
          n += "\n@media only screen and (max-width: " + sizes[s].max + "px) { \n" + (this.props.emailMode ? "." : ".builder-block.") + e.id + (this.props.emailMode ? "-subject" : "") + " {" + mapToCss(this.props.emailMode ? omit(l, a) : l, 4, this.props.emailMode) + " } }", this.props.emailMode && u && Object.keys(u).length && (n += "\n@media only screen and (max-width: " + sizes[s].max + "px) { \n.builder-block." + e.id + " {" + mapToCss(u, 4, !0) + " } }");
        }
      }
      var p = e.animations;

      if (!this.privateState.state.isBrowser && p && p.length) {
        var d = p[0];

        if (d) {
          var c = d.steps && d.steps[0];
          if (c) c.styles && (n += "\n.builder-block." + e.id + " {" + mapToCss(c, 2, !0) + "}");
        }
      }

      return n;
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.eval = function (e) {
    return this.stringToFunction(e)(this.privateState.state, void 0, this.block, builder, Device, this.privateState.update, Builder, this.privateState.context);
  }, t.prototype.componentWillUnmount = function () {
    Builder.isEditing && removeEventListener("message", this.onWindowMessage);
  }, t.prototype.componentDidMount = function () {
    var e = this,
        t = this.block,
        n = t && t.animations;

    if (Builder.isEditing && addEventListener("message", this.onWindowMessage), n) {
      var r = {
        animations: fastClone(n)
      };
      if (t.bindings) for (var i in t.bindings) {
        if (i.startsWith("animations.")) {
          var o = this.stringToFunction(t.bindings[i]);
          void 0 !== o && set(r, i, o(this.privateState.state, null, t, builder, null, null, Builder, this.privateState.context));
        }
      }
      Builder.animator.bindAnimations(r.animations.filter(function (e) {
        return "hover" !== e.trigger;
      }).map(function (t) {
        return _assign(_assign({}, t), {
          elementId: e.block.id
        });
      }));
    }
  }, t.prototype.getElement = function (e, n) {
    var r,
        i,
        o = this;
    void 0 === e && (e = 0), void 0 === n && (n = this.privateState.state);
    var s,
        a = this.props,
        l = (a.child, a.fieldName, this.block),
        u = (l.tagName || "div").toLowerCase();

    if ("template" === u) {
      var p = l.children ? l.children.map(function (e) {
        return blockToHtmlString(e);
      }).join(" ") : "";
      return console.debug("template html", p), jsx("template", _assign({}, l.properties, {
        dangerouslySetInnerHTML: {
          __html: p
        }
      }));
    }

    var d = l.component && (l.component.name || l.component.component),
        c = null;
    l.component && !l.component["class"] && (l.component && l.component.tag ? s = l.component.tag : (c = Builder.components.find(function (e) {
      return e.name === d;
    }) || null) && c["class"] ? s = c["class"] : c && c.tag && (s = c.tag));

    var m = _assign(_assign({}, l.properties), {
      style: {}
    });

    if (m = _assign(_assign({}, m.properties), m), l.component && (m.component = fastClone(l.component)), l.bindings) for (var h in l.bindings) {
      var f = this.stringToFunction(l.bindings[h]);
      set(m, h, f(n, null, l, api(), Device, null, Builder, this.privateState.context));
    }
    if (m.hide) return null;
    if (delete m.hide, ("show" in m || l.bindings && l.bindings.show) && !m.show) return null;

    if (delete m.show, l.actions) {
      var g = function g(e) {
        var t = l.actions[e];

        m["on" + capitalize(e)] = function (e) {
          var r = n;
          return "undefined" != typeof Proxy && (r = new Proxy(n, {
            set: function set(e, t, n) {
              return e[t] = n, o.privateState.rootState[t] = n, !0;
            }
          })), o.stringToFunction(t, !1)(r, e, o.block, builder, Device, o.privateState.update, Builder, o.privateState.context);
        };
      };

      for (var h in l.actions) {
        g(h);
      }
    }

    var b = (m.component || m.options) && _assign(_assign({}, m.options), m.component.options || m.component.data),
        v = voidElements.has(u),
        y = c && (c.fragment || c.noWrap),
        _ = _assign(_assign(_assign({}, omit(m, ["class", "component", "attr"])), ((r = {})["string" != typeof u || u.includes("-") ? "class" : "className"] = "builder-block " + this.id + (l["class"] ? " " + l["class"] : "") + (!l.component || ["Image", "Video", "Banner"].indexOf(d) > -1 ? "" : " builder-has-component") + (m["class"] ? " " + m["class"] : "") + (Builder.isEditing && (null === (i = this.privateState.state._spacer) || void 0 === i ? void 0 : i.parent) === l.id ? " builder-spacer-parent" : ""), r.key = this.id + e, r["builder-id"] = this.id, r)), 0 !== e && {
      "builder-index": e
    });

    Builder.isIframe && (_["builder-inline-styles"] = m.attr && m.attr.style ? Object.keys(m.style).reduce(function (e, t) {
      return (e ? e + ";" : "") + cssCase(t) + ":" + m.style[t] + ";";
    }, "") : ""), (_.properties && _.properties.href || _.href) && "div" === u && (u = "a"), "a" === u && (u = Link);
    var x = l.children || _.children || [];
    return jsx(React.Fragment, null, jsx(ClassNames, null, function (e) {
      var n = e.css;
      e.cx;

      if (!o.props.emailMode) {
        var r = " " + n(o.emotionCss);
        _["class"] && (_["class"] += r), _.className && (_.className += r);
      }

      return jsx(BuilderAsyncRequestsContext.Consumer, null, function (e) {
        return o._asyncRequests = e && e.requests, o._errors = e && e.errors, o._logs = e && e.logs, v ? jsx(u, _assign({}, _)) : s && (y || o.props.emailMode) ? jsx(s, _assign({}, b, {
          attributes: _,
          builderBlock: l,
          builderState: o.privateState
        })) : jsx(u, _assign({}, _), s && jsx(s, _assign({
          builderState: o.privateState,
          builderBlock: l
        }, b)), l.text || m.text ? m.text : !s && x && Array.isArray(x) && x.length ? x.map(function (e, n) {
          return jsx(t, {
            key: (o.id || "") + n,
            block: e,
            index: n,
            size: o.props.size,
            fieldName: o.props.fieldName,
            child: o.props.child,
            emailMode: o.props.emailMode
          });
        }) : null);
      });
    }));
  }, Object.defineProperty(t.prototype, "id", {
    get: function get() {
      var e = this.block;
      return e.id.startsWith("builder") ? e.id : "builder-" + e.id;
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.contents = function (e) {
    var t = this,
        n = this.block;

    if (this.privateState = e, n.repeat && n.repeat.collection) {
      var r = n.repeat.collection,
          i = last((r || "").trim().split("(")[0].trim().split(".")),
          o = n.repeat.itemName || (i ? i + "Item" : "item"),
          s = this.stringToFunction(r)(e.state, null, n, api(), Device, null, Builder, this.privateState.context);
      return Array.isArray(s) ? s.map(function (n, r) {
        var i,
            s = _assign(_assign({}, e.state), ((i = {
          $index: r,
          $item: n
        })[o] = n, i["$" + o + "Index"] = r, i));

        return jsx(BuilderStoreContext.Provider, {
          key: r,
          value: _assign(_assign({}, e), {
            state: s
          })
        }, t.getElement(r, s));
      }) : null;
    }

    return this.getElement();
  }, t.prototype.render = function () {
    var e = this;
    return this.state.hasError ? jsx("span", {
      css: {
        display: "inline-block",
        padding: 5,
        color: "#999",
        fontSize: 11,
        fontStyle: "italic"
      }
    }, "Builder block error :( Check console for details") : jsx(BuilderStoreContext.Consumer, null, function (t) {
      return e.contents(t);
    });
  }, t;
}(React.Component),
    BuilderBlocks = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.onClickEmptyBlocks = function () {
      var e;
      Builder.isIframe && t.noBlocks && (null === (e = window.parent) || void 0 === e || e.postMessage({
        type: "builder.clickEmptyBlocks",
        data: {
          parentElementId: t.parentId,
          dataPath: t.path
        }
      }, "*"));
    }, t;
  }

  return __extends(t, e), Object.defineProperty(t.prototype, "isRoot", {
    get: function get() {
      return !this.props.child;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t.prototype, "noBlocks", {
    get: function get() {
      var e = this.props.blocks;
      return !(e && e.length);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t.prototype, "path", {
    get: function get() {
      var e = this.props.dataPath || "";
      return e.trim() && (e.startsWith("this.") ? e = e.replace("this.", "") : e.startsWith("component.options.") || (e = "component.options." + e)), e;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t.prototype, "parentId", {
    get: function get() {
      return this.props.parentElementId ? this.props.parentElementId : this.props.parent && this.props.parent.id;
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.render = function () {
    var e = this,
        t = this.props.blocks,
        n = this.props.emailMode ? "span" : "div";
    return jsx(n, {
      className: "builder-blocks" + (this.noBlocks ? " no-blocks" : "") + (this.props.child ? " builder-blocks-child" : "") + (this.props.className ? " " + this.props.className : ""),
      "builder-type": "blocks",
      "builder-path": Builder.isIframe ? this.path : void 0,
      css: _assign(_assign({}, !this.props.emailMode && {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch"
      }), this.props.style),
      onClick: function onClick() {
        e.noBlocks && e.onClickEmptyBlocks();
      }
    }, t && Array.isArray(t) && t.map(function (t, n) {
      return t && "@builder.io/sdk:Element" === t["@type"] ? jsx(BuilderBlock, {
        key: t.id,
        block: t,
        index: n,
        fieldName: e.props.fieldName,
        child: e.props.child,
        emailMode: e.props.emailMode
      }) : t;
    }) || t);
  }, t;
}(React.Component),
    NoWrap = function NoWrap(e) {
  return e.children;
},
    BuilderContent = function (_super) {
  function BuilderContent() {
    var _this = null !== _super && _super.apply(this, arguments) || this;

    return _this.ref = null, _this.state = {
      loading: !0,
      data: null,
      updates: 1
    }, _this.onWindowMessage = function (event) {
      var _a,
          message = event.data;

      if (message) switch (message.type) {
        case "builder.patchUpdates":
          var data = message.data;
          if (!data || !data.data) break;
          var patches = data.data[null === (_a = _this.state.data) || void 0 === _a ? void 0 : _a.id];
          if (!patches || !patches.length) return;
          location.href.includes("builder.debug=true") && eval("debugger");

          for (var _i = 0, patches_1 = patches; _i < patches_1.length; _i++) {
            var patch = patches_1[_i];
            applyPatchWithMinimalMutationChain(_this.state.data, patch);
          }

          _this.setState({
            updates: _this.state.updates + 1,
            data: _this.state.data ? _assign({}, _this.state.data) : _this.state.data
          }), _this.props.contentLoaded && _this.props.contentLoaded(_this.state.data.data);
      }
    }, _this.subscriptions = new Subscription(), _this.firstLoad = !0, _this.clicked = !1, _this.trackedImpression = !1, _this.intersectionObserver = null, _this.onClick = function (e) {
      var t = e.nativeEvent,
          n = _this.state.data;
      n && (builder.autoTrack && _this.builder.trackInteraction(n.id, n.variationId, _this.clicked, t), _this.clicked || (_this.clicked = !0));
    }, _this;
  }

  return __extends(BuilderContent, _super), Object.defineProperty(BuilderContent.prototype, "builder", {
    get: function get() {
      return this.props.builder || builder;
    },
    enumerable: !0,
    configurable: !0
  }), BuilderContent.prototype.componentDidMount = function () {
    this.subscribeToContent(), Builder.isEditing && addEventListener("message", this.onWindowMessage);
  }, BuilderContent.prototype.subscribeToContent = function () {
    var e = this;
    "_inline" !== this.props.modelName && this.subscriptions.add(builder.queueGetContent(this.props.modelName, this.props.options).subscribe(function (t) {
      var n = t && t[0];

      if (e.setState({
        data: n
      }), n && e.firstLoad) {
        if (builder.autoTrack) {
          var r = !1;
          if ("function" == typeof IntersectionObserver && e.ref) try {
            (e.intersectionObserver = new IntersectionObserver(function (t, r) {
              t.forEach(function (t) {
                t.intersectionRatio > 0 && !e.trackedImpression && (e.builder.trackImpression(n.id, n.variationId), e.trackedImpression = !0, e.ref && r.unobserve(e.ref));
              });
            })).observe(e.ref), r = !0;
          } catch (e) {
            console.warn("Could not bind intersection observer");
          }
          r || (e.trackedImpression = !0, e.builder.trackImpression(n.id, n.variationId));
        }

        e.firstLoad = !1;
      }

      e.props.contentLoaded && e.props.contentLoaded(n && n.data);
    }, function (t) {
      e.props.contentError && e.props.contentError(t);
    }));
  }, BuilderContent.prototype.componentWillUnmount = function () {
    Builder.isEditing && removeEventListener("message", this.onWindowMessage), this.subscriptions.unsubscribe(), this.intersectionObserver && this.ref && this.intersectionObserver.unobserve(this.ref);
  }, BuilderContent.prototype.render = function () {
    var e = this;
    if (this.props.dataOnly) return null;
    var t = this.state,
        n = t.data,
        r = t.loading,
        i = (this.props.inline || !Builder.isBrowser || this.firstLoad) && this.props.options && this.props.options.initialContent && this.props.options.initialContent[0] || n,
        o = this.props.dataOnly ? NoWrap : "div";
    return React.createElement(o, _assign({}, !this.props.dataOnly && {
      ref: function ref(t) {
        return e.ref = t;
      }
    }, {
      className: "builder-content",
      onClick: this.onClick,
      "builder-content-id": i && i.id,
      "builder-model": this.props.modelName
    }), this.props.children(i && i.data, r, i));
  }, BuilderContent;
}(React.Component);

function unwrapExports(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e["default"] : e;
}

function createCommonjsModule(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}

var onChange_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var n = Symbol("target"),
      r = Symbol("unsubscribe"),
      i = function i(e, t) {
    return t && t.toString && (e && (e += "."), e += t.toString()), e;
  },
      o = function o(e) {
    return Array.isArray(e) ? e.slice() : Object.assign({}, e);
  },
      s = function s(e, t, _s) {
    if ("undefined" == typeof Proxy) return e;
    void 0 === _s && (_s = {});

    var a,
        l,
        u = Symbol("ProxyTarget"),
        p = !1,
        d = !1,
        c = !1,
        m = _s.equals || Object.is,
        h = new WeakMap(),
        f = new WeakMap(),
        g = new WeakMap(),
        b = function b(e, n, r, s) {
      if (!c) if (p) {
        if (p && l && void 0 !== r && void 0 !== s && "length" !== n) {
          var u = l;
          e !== a && function (e, t) {
            for (var n; e;) {
              -1 === (n = e.indexOf(".")) && (n = e.length), t(e.slice(0, n)), e = e.slice(n + 1);
            }
          }(e = e.replace(a, "").slice(1), function (e) {
            u[e] = o(u[e]), u = u[e];
          }), u[n] = r;
        }

        d = !0;
      } else t(i(e, n), s, r);
    },
        v = function v(e, t) {
      var n = h ? h.get(e) : void 0;
      n && n["delete"](t);
    },
        y = function y(e, t) {
      if (c) return e;
      f.set(e, t);
      var n = g.get(e);
      return void 0 === n && (n = new Proxy(e, x), g.set(e, n)), n;
    },
        _ = function _(e) {
      return c || !0 === _s.ignoreSymbols && "symbol" == typeof e;
    },
        x = {
      get: function get(e, t, o) {
        if (t === u || t === n) return e;
        if (t === r && "" === f.get(e)) return function (e) {
          return c = !0, h = null, f = null, g = null, e;
        }(e);
        var a = Reflect.get(e, t, o);
        if (function (e) {
          return null === e || "object" != typeof e && "function" != typeof e;
        }(a) || function (e) {
          return e instanceof RegExp || e instanceof Number;
        }(a) || "constructor" === t || !0 === _s.isShallow) return a;

        var l = function (e, t) {
          var n = h ? h.get(e) : void 0;
          if (n) return n;
          n = new Map(), h.set(e, n);
          var r = n.get(t);
          return r || (r = Reflect.getOwnPropertyDescriptor(e, t), n.set(t, r)), r;
        }(e, t);

        if (l && !l.configurable) {
          if (l.set && !l.get) return;
          if (!1 === l.writable) return a;
        }

        return y(a, i(f.get(e), t));
      },
      set: function set(e, t, n, r) {
        n && void 0 !== n[u] && (n = n[u]);

        var i = _(t),
            o = i ? null : Reflect.get(e, t, r),
            s = Reflect.set(e[u] || e, t, n);

        return i || m(o, n) || b(f.get(e), t, o, n), s;
      },
      defineProperty: function defineProperty(e, t, n) {
        var r = Reflect.defineProperty(e, t, n);
        return _(t) || (v(e, t), b(f.get(e), t, void 0, n.value)), r;
      },
      deleteProperty: function deleteProperty(e, t) {
        if (!Reflect.has(e, t)) return !0;

        var n = _(t),
            r = n ? null : Reflect.get(e, t),
            i = Reflect.deleteProperty(e, t);

        return n || (v(e, t), b(f.get(e), t, r)), i;
      },
      apply: function apply(e, t, n) {
        var r = t instanceof Date;

        if (r && (t = t[u]), !p) {
          p = !0, r && (l = t.valueOf()), (Array.isArray(t) || "[object Object]" === toString.call(t)) && (l = o(t[u])), a = (a = f.get(e)).slice(0, Math.max(a.lastIndexOf("."), 0));
          var i = Reflect.apply(e, t, n);
          return p = !1, (d || r && !m(l, t.valueOf())) && (b(a, "", l, t[u] || t), l = null, d = !1), i;
        }

        return Reflect.apply(e, t, n);
      }
    },
        k = y(e, "");

    return t = t.bind(k), k;
  };

  s.target = function (e) {
    return e[n] || e;
  }, s.unsubscribe = function (e) {
    return e[r] || e;
  }, e.exports = s, t["default"] = s;
}),
    onChange = unwrapExports(onChange_1),
    nextTick = Builder.nextTick;

function debounceNextTick(e, t, n) {
  return void 0 === t && "function" == typeof e ? debounceNextTickImpl(e) : {
    configurable: !0,
    enumerable: n.enumerable,
    get: function get() {
      return Object.defineProperty(this, t, {
        configurable: !0,
        enumerable: n.enumerable,
        value: debounceNextTickImpl(n.value)
      }), this[t];
    }
  };
}

function debounceNextTickImpl(e) {
  var t = null,
      n = null;
  return function () {
    var e = t;
    if (t = [].slice.call(arguments), n = this, null !== e) return;
    nextTick(r);
  };

  function r() {
    e.apply(n, t), t = null, n = null;
  }
}

function throttle(e, t, n) {
  var r, i, o;
  void 0 === n && (n = {});

  var s = null,
      a = 0,
      l = function l() {
    a = !1 === n.leading ? 0 : Date.now(), s = null, o = e.apply(r, i), s || (r = i = null);
  };

  return function () {
    var u = Date.now();
    a || !1 !== n.leading || (a = u);
    var p = t - (u - a);
    return r = this, i = arguments, p <= 0 || p > t ? (s && (clearTimeout(s), s = null), a = u, o = e.apply(r, i), s || (r = i = null)) : s || !1 === n.trailing || (s = setTimeout(l, p)), o;
  };
}

var BuilderMetaContext = React.createContext({
  emailMode: !1,
  ampMode: !1,
  isServer: !1
}),
    size = function size(e) {
  return Object.keys(e).length;
};

function debounce(e, t, n) {
  var r;
  return void 0 === n && (n = !1), function () {
    var i = this,
        o = arguments;
    clearTimeout(r), r = setTimeout(function () {
      r = null, n || e.apply(i, o);
    }, t), n && !r && e.apply(i, o);
  };
}

var fontsLoaded = new Set();

function pick$1(e, t) {
  return t.reduce(function (t, n) {
    return e && e.hasOwnProperty(n) && (t[n] = e[n]), t;
  }, {});
}

var fetch$1 = Builder.isBrowser ? window.fetch : require("node-fetch"),
    sizeMap = {
  desktop: "large",
  tablet: "medium",
  mobile: "small"
};

function decorator(e) {
  return function () {
    for (var t = [], n = 0; n < arguments.length; n++) {
      t[n] = arguments[n];
    }

    if (3 === t.length) {
      var r = t[0],
          i = t[1],
          o = t[2];
      if (o && (o.value || o.get)) return t = [], s(r, i, o);
    }

    return s;

    function s(n, r, i) {
      var o,
          s = i.value ? "value" : "get";
      return _assign(_assign({}, i), ((o = {})[s] = e.apply(void 0, __spreadArrays([i[s]], t)), o));
    }
  };
}

var Throttle = decorator(throttle),
    fetchCache = {},
    tryEval = function tryEval(e, t, n) {
  void 0 === t && (t = {});
  var r = e;

  if ("string" == typeof r && r.trim()) {
    var i = !(r.includes(";") || r.includes(" return ")),
        o = function o() {};

    try {
      Builder.isBrowser && (o = new Function("state", "var rootState = state;\n        if (typeof Proxy !== 'undefined') {\n          rootState = new Proxy(rootState, {\n            set: function () {\n              return false;\n            },\n            get: function (target, key) {\n              if (key === 'state') {\n                return state;\n              }\n              return target[key]\n            }\n          });\n        }\n        with (rootState) {\n          " + (i ? "return (" + e + ");" : e) + ";\n        }"));
    } catch (e) {
      Builder.isBrowser && console.warn("Could not compile javascript", e);
    }

    try {
      return Builder.isBrowser ? o(t || {}) : new (0, safeDynamicRequire("vm2").VM)({
        sandbox: _assign(_assign({}, t), {
          state: t
        })
      }).run(r.replace(/(^|;)return /, "$1"));
    } catch (t) {
      n && n.push(t), Builder.isBrowser ? console.warn("Builder custom code error:", t.message, "in", e, t.stack) : process.env.DEBUG && console.debug("Builder custom code error:", t.message, "in", e, t.stack);
    }
  }
};

function searchToObject(e) {
  var t = (e.search || "").substring(1).split("&"),
      n = {};

  for (var r in t) {
    if ("" !== t[r]) {
      var i = t[r].split("=");
      n[decodeURIComponent(i[0])] = decodeURIComponent(i[1]);
    }
  }

  return n;
}

var BuilderPage = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;

    if (n.subscriptions = new Subscription(), n.onStateChange = new BehaviorSubject(null), n.asServer = !1, n.contentRef = null, n.styleRef = null, n.rootState = onChange({}, function () {
      return n.updateState();
    }), n.lastJsCode = "", n.lastHttpRequests = {}, n.httpSubscriptionPerKey = {}, n.ref = null, n.messageListener = function (e) {
      var t = e.data;

      switch (t.type) {
        case "builder.updateSpacer":
          var r = t.data;
          n.rootState._spacer;
          n.updateState(function (e) {
            e._spacer = r;
          });
          break;

        case "builder.resetState":
          var i = t.data,
              o = i.state;

          if (i.model === n.name) {
            for (var s in n.rootState) {
              delete n.rootState[s];
            }

            Object.assign(n.rootState, o), n.setState(_assign(_assign({}, n.state), {
              state: n.rootState,
              updates: (n.state && n.state.updates || 0) + 1
            }));
          }

          break;

        case "builder.resetSymbolState":
          var a = t.data.state,
              l = (o = a.state, a.model, a.id);

          if (n.props.builderBlock && n.props.builderBlock === l) {
            for (var s in n.rootState) {
              delete n.rootState[s];
            }

            Object.assign(n.rootState, o), n.setState(_assign(_assign({}, n.state), {
              state: n.rootState,
              updates: (n.state && n.state.updates || 0) + 1
            }));
          }

      }
    }, n.resizeFn = function () {
      var e = n.deviceSizeState;
      e !== n.state.state.deviceSize && n.setState(_assign(_assign({}, n.state), {
        updates: (n.state && n.state.updates || 0) + 1,
        state: Object.assign(n.rootState, _assign(_assign({}, n.state.state), {
          deviceSize: e
        }))
      }));
    }, n.resizeListener = Builder.isEditing ? throttle(n.resizeFn, 200) : debounce(n.resizeFn, 400), n.mounted = !1, n.updateState = function (e) {
      var t = n.rootState;
      e && e(t), n.mounted ? n.setState({
        update: n.updateState,
        state: t,
        updates: (n.state && n.state.updates || 0) + 1
      }) : n.state = _assign(_assign({}, n.state), {
        update: n.updateState,
        state: t,
        updates: (n.state && n.state.updates || 0) + 1
      }), n.notifyStateChange();
    }, n.onContentLoaded = function (e) {
      if (e && e.meta && "page" === e.meta.kind) {
        var t = new Date();
        t.setDate(t.getDate() + 30), n.builder.setCookie("builder.lastPageViewed", [e.id, e.variationId || e.testVariationId || e.id].join(","), t);
      }

      if (("page" === n.name || "docs-content" === n.name) && Builder.isBrowser && e) {
        var r = e.title,
            i = e.pageTitle,
            o = e.description,
            s = e.pageDescription;

        if ((r || i) && (document.title = r || i), o || s) {
          var a = document.querySelector('meta[name="description"]');
          a || ((a = document.createElement("meta")).setAttribute("name", "description"), document.head.appendChild(a)), a.setAttribute("content", o || s);
        }
      }

      if (Builder.isEditing && n.notifyStateChange(), n.props.contentLoaded && n.props.contentLoaded(e), e && e.inputs && Array.isArray(e.inputs) && e.inputs.length && (e.state || (e.state = {}), e.inputs.forEach(function (t) {
        t && t.name && void 0 !== t.defaultValue && void 0 === e.state[t.name] && (e.state[t.name] = t.defaultValue);
      })), e && e.state) {
        var l = _assign(_assign({}, n.state), {
          updates: (n.state && n.state.updates || 0) + 1,
          state: Object.assign(n.rootState, _assign(_assign(_assign(_assign({}, n.state.state), {
            location: n.locationState,
            deviceSize: n.deviceSizeState,
            device: n.device
          }), e.state), n.props.data))
        });

        n.mounted ? n.setState(l) : n.state = l;
      }

      if (e && e.jsCode && Builder.isBrowser) {
        var u = !1;

        if (Builder.isEditing && (n.lastJsCode === e.jsCode ? u = !0 : n.lastJsCode = e.jsCode), !u) {
          var p = n.state.state;

          try {
            new Function("data", "ref", "state", "update", "element", "Builder", "builder", "context", e.jsCode)(e, n, p, n.state.update, n.ref, Builder, builder, n.state.context);
          } catch (t) {
            Builder.isBrowser ? console.warn("Builder custom code error:", t.message, "in", e.jsCode, t.stack) : process.env.DEBUG && console.debug("Builder custom code error:", t.message, "in", e.jsCode, t.stack);
          }
        }
      }

      if (e && e.httpRequests && !n.props.noAsync && !(u = !1)) {
        var d = function d(t) {
          var r = e.httpRequests[t];
          if (r && (!n.data[t] || Builder.isEditing)) if (Builder.isBrowser) {
            var i = n.evalExpression(r);
            if (Builder.isEditing && n.lastHttpRequests[t] === i) return "continue";
            n.lastHttpRequests[t] = i;
            var o = r.match(/builder\.io\/api\/v2\/([^\/\?]+)/i);
            o && o[1];
            n.throttledHandleRequest(t, i);
            var s = n.httpSubscriptionPerKey[t];
            s && s.unsubscribe();
            var a = n.httpSubscriptionPerKey[t] = n.onStateChange.subscribe(function () {
              var e = n.evalExpression(r);
              e !== i && (n.throttledHandleRequest(t, e), n.lastHttpRequests[t] = e);
            });
            n.subscriptions.add(a);
          } else n.handleRequest(t, n.evalExpression(r));
        };

        for (var c in e.httpRequests) {
          d(c);
        }
      }
    }, n.state = {
      context: t.context || {},
      state: Object.assign(n.rootState, _assign(_assign(_assign(_assign({}, n.props.content && n.props.content.data && n.props.content.data.state), {
        isBrowser: Builder.isBrowser,
        isServer: !Builder.isBrowser,
        _hydrate: t.hydrate,
        location: n.locationState,
        deviceSize: n.deviceSizeState,
        device: n.device
      }), n.getHtmlData()), t.data)),
      updates: 0,
      key: 0,
      update: n.updateState
    }, Builder.isBrowser) {
      var r = n.props.apiKey;
      r && r !== n.builder.apiKey && (n.builder.apiKey = r), n.props.content && n.onContentLoaded(n.props.content.content || n.props.content.data);
    }

    return n;
  }

  return __extends(t, e), Object.defineProperty(t.prototype, "name", {
    get: function get() {
      return this.props.model || this.props.modelName || this.props.name;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t.prototype, "element", {
    get: function get() {
      return this.ref;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t.prototype, "builder", {
    get: function get() {
      return this.props.builder || builder;
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.getHtmlData = function () {
    var e = this.props.content && this.props.content.id || this.props.entry,
        t = e && Builder.isBrowser && document.querySelector('script[data-builder-json="' + e + '"],script[data-builder-state="' + e + '"]');
    return t ? JSON.parse(t.innerText) : {};
  }, Object.defineProperty(t.prototype, "device", {
    get: function get() {
      return this.builder.getUserAttributes().device || "desktop";
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t.prototype, "locationState", {
    get: function get() {
      return _assign(_assign({}, pick$1(this.location, ["pathname", "hostname", "search", "host"])), {
        path: this.location.pathname && this.location.pathname.split("/").slice(1) || "",
        query: searchToObject(this.location)
      });
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t.prototype, "deviceSizeState", {
    get: function get() {
      return Builder.isBrowser ? sizes.getSizeForWidth(window.innerWidth) : sizeMap[this.device] || "large";
    },
    enumerable: !0,
    configurable: !0
  }), t.renderInto = function (e, n, r, i) {
    void 0 === n && (n = {}), void 0 === r && (r = !0), void 0 === i && (i = !1), console.debug("BuilderPage.renderInto", e, n, r, this);
    var o = e instanceof HTMLElement ? e : document.querySelector(e);

    if (o) {
      var s = o.classList.contains("builder-hydrated");

      if (!s || i) {
        o.classList.add("builder-hydrated");
        var a = r && o.innerHTML.includes("builder-block");

        if (!o.classList.contains("builder-component")) {
          var l = o.querySelector(".builder-api-styles") || (o.previousElementSibling && o.previousElementSibling.matches(".builder-api-styles") ? o.previousElementSibling : null),
              u = "";
          if (l) l.innerHTML.replace(/\/\*start:([^\*]+?)\*\/([\s\S]*?)\/\*end:([^\*]+?)\*\//g, function (e, t, n) {
            var r = null;

            try {
              r = document.querySelector('[data-emotion-css="' + t + '"]');
            } catch (e) {
              console.warn(e);
            }

            return r ? r.innerHTML = n : Builder.isEditing || (u += e), e;
          }), Builder.nextTick(function () {
            l.innerHTML = u;
          });
          var p = o.querySelector(".builder-component");
          p ? o = p : a = !1;
        }

        location.search.includes("builder.debug=true") && console.debug("hydrate", a, o);
        var d = o;

        if (!s) {
          var c = document.createElement("div");
          o.insertAdjacentElement("beforebegin", c), c.appendChild(o), d = c;
        }

        if ((Builder.isEditing || Builder.isBrowser && location.search.includes("builder.preview=")) && (a = !1), a && o) {
          var m = ReactDOM.render(React.createElement(t, _assign({}, n)), d, d.builderRootRef);
          return d.builderRootRef = m, m;
        }

        var h = ReactDOM.render(React.createElement(t, _assign({}, n)), d, d.builderRootRef);
        return d.builderRootRef = h, h;
      }

      console.debug("Tried to hydrate multiple times");
    }
  }, t.prototype.componentDidMount = function () {
    var e,
        t = this;
    this.mounted = !0, this.asServer && (this.asServer = !1, this.updateState(function (e) {
      e.isBrowser = !0, e.isServer = !1;
    })), Builder.isIframe && (null === (e = window.parent) || void 0 === e || e.postMessage({
      type: "builder.sdkInjected",
      data: {
        modelName: this.name
      }
    }, "*")), Builder.isBrowser && (window.addEventListener("resize", this.resizeListener), Builder.isEditing && window.addEventListener("message", this.messageListener), setTimeout(function () {
      window.dispatchEvent(new CustomEvent("builder:component:load", {
        detail: {
          ref: t
        }
      }));
    }));
  }, t.prototype.notifyStateChange = function () {
    if (this && this.state) {
      var e = this.state.state;
      this.props.onStateChange && this.props.onStateChange(e), Builder.isBrowser && window.dispatchEvent(new CustomEvent("builder:component:stateChange", {
        detail: {
          state: e,
          ref: this
        }
      })), this.onStateChange.next(e);
    }
  }, t.prototype.processStateFromApi = function (e) {
    return e;
  }, Object.defineProperty(t.prototype, "location", {
    get: function get() {
      return this.props.location || (Builder.isBrowser ? location : {});
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.getCssFromFont = function (e, t) {
    var n = e.family + (e.kind && !e.kind.includes("#") ? ", " + e.kind : ""),
        r = n.split(",")[0],
        i = e.fileUrl ? e.fileUrl : e.files && e.files.regular,
        o = "";
    if (i && n && r && (o += ("\n@font-face {\n  font-family: " + n + ';\n  src: local("' + r + "\"), url('" + i + "') format('woff2');\n  font-display: swap;\n  font-weight: 400;\n}\n        ").trim()), e.files) for (var s in e.files) {
      if (String(Number(s)) === s) {
        var a = e.files[s];
        a && a !== i && (o += ("\n@font-face {\n  font-family: " + n + ";\n  src: url('" + a + "') format('woff2');\n  font-display: swap;\n  font-weight: " + s + ";\n}\n          ").trim());
      }
    }
    return o;
  }, t.prototype.componentWillUnmount = function () {
    this.unsubscribe(), Builder.isBrowser && (window.removeEventListener("resize", this.resizeListener), window.removeEventListener("message", this.messageListener));
  }, t.prototype.getFontCss = function (e) {
    var t = this;
    return e.customFonts && e.customFonts.length && e.customFonts.map(function (n) {
      return t.getCssFromFont(n, e);
    }).join(" ") || "";
  }, t.prototype.ensureFontsLoaded = function (e) {
    if (e.customFonts && Array.isArray(e.customFonts)) for (var t = 0, n = e.customFonts; t < n.length; t++) {
      var r = n[t],
          i = r.fileUrl ? r.fileUrl : r.files && r.files.regular;

      if (!fontsLoaded.has(i)) {
        var o = this.getCssFromFont(r, e);
        if (fontsLoaded.add(i), !o) continue;
        var s = document.createElement("style");
        s.className = "builder-custom-font", s.setAttribute("data-builder-custom-font", i), s.innerHTML = o, document.head.appendChild(s);
      }
    }
  }, t.prototype.getCss = function (e) {
    return (e.cssCode || "") + this.getFontCss(e);
  }, Object.defineProperty(t.prototype, "data", {
    get: function get() {
      var e = _assign(_assign(_assign({}, this.props.content && this.props.content.data.state), this.props.data), this.state.state);

      return Object.assign(this.rootState, e), e;
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.componentDidUpdate = function (e) {
    var t = this;
    this.props.data && e.data !== this.props.data && this.state.update(function (e) {
      Object.assign(e, t.props.data);
    }), Builder.isEditing && this.props.content && e.content !== this.props.content && this.onContentLoaded(this.props.content);
  }, t.prototype.checkStyles = function (e) {
    if (this.styleRef) {
      var t = this.getCss(e);
      this.styleRef.innerHTML !== t && (this.styleRef.innerHTML = t);
    }
  }, t.prototype.reload = function () {
    this.setState({
      key: this.state.key + 1
    });
  }, t.prototype.render = function () {
    var e = this,
        t = this.props.content;
    t && t.content && (t = _assign(_assign({}, t), {
      data: t.content
    }));
    var n = this.props.data && size(this.props.data) && hash(this.props.data),
        r = Builder.isEditing ? this.name : this.props.entry;
    !Builder.isEditing && n && n.length < 300 && (r += ":" + n);
    var i = this.props.dataOnly ? React.Fragment : "div";
    return React.createElement(i, {
      className: "builder-component",
      "data-name": this.name,
      "data-timestamp": Date.now(),
      "date-source": "Rendered by Builder.io on " + new Date().toUTCString(),
      key: this.state.key,
      ref: function ref(t) {
        return e.ref = t;
      }
    }, React.createElement(BuilderMetaContext.Consumer, null, function (n) {
      return React.createElement(BuilderMetaContext.Provider, {
        value: "boolean" == typeof e.props.ampMode ? _assign(_assign({}, n), {
          ampMode: e.props.ampMode
        }) : n
      }, React.createElement(BuilderAsyncRequestsContext.Consumer, null, function (n) {
        return e._asyncRequests = n && n.requests, e._errors = n && n.errors, e._logs = n && n.logs, React.createElement(BuilderContent, {
          builder: e.builder,
          ref: function ref(t) {
            return e.contentRef = t;
          },
          inline: e.props.inlineContent,
          contentLoaded: e.onContentLoaded,
          options: _assign(_assign({
            key: r,
            entry: e.props.entry
          }, t && size(t) && {
            initialContent: [t]
          }), e.props.options),
          contentError: e.props.contentError,
          modelName: e.name || "page"
        }, function (t, n, r) {
          var i, o;
          return e.props.dataOnly ? null : (r && r.id && (e.state.context.builderContent = r), Builder.isBrowser && Builder.nextTick(function () {
            e.checkStyles(t);
          }), t ? React.createElement("div", {
            "data-builder-component": e.name,
            "data-builder-content-id": r.id,
            "data-builder-variation-id": r.testVariationId || r.variationId || r.id
          }, e.getCss(t) && React.createElement("style", {
            ref: function ref(t) {
              return e.styleRef = t;
            },
            className: "builder-custom-styles",
            dangerouslySetInnerHTML: {
              __html: e.getCss(t)
            }
          }), React.createElement(BuilderStoreContext.Provider, {
            value: _assign(_assign({}, e.state), {
              rootState: e.rootState,
              state: e.data,
              content: r,
              renderLink: e.props.renderLink
            })
          }, React.createElement(BuilderBlocks, {
            key: String(!!(null === (o = null === (i = t) || void 0 === i ? void 0 : i.blocks) || void 0 === o ? void 0 : o.length)),
            emailMode: e.props.emailMode,
            fieldName: "blocks",
            blocks: t.blocks
          }))) : n ? React.createElement("div", {
            "data-builder-component": e.name,
            className: "builder-loading"
          }, e.props.children) : React.createElement("div", {
            "data-builder-component": e.name,
            className: "builder-no-content"
          }));
        });
      }));
    }));
  }, t.prototype.evalExpression = function (e) {
    var t = this,
        n = this.data;
    return e.replace(/{{([^}]+)}}/g, function (e, r) {
      return tryEval(r, n, t._errors);
    });
  }, t.prototype.throttledHandleRequest = function (e, t) {
    return this.handleRequest(e, t);
  }, t.prototype.handleRequest = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      var n,
          r,
          i,
          o,
          s = this;
      return __generator(this, function (a) {
        return Builder.isIframe && fetchCache[t] ? (this.updateState(function (n) {
          n[e] = fetchCache[t];
        }), [2, fetchCache[t]]) : (n = function n() {
          return __awaiter(s, void 0, void 0, function () {
            var n, r, i;
            return __generator(this, function (o) {
              switch (o.label) {
                case 0:
                  n = Date.now(), Builder.isBrowser || console.time("Fetch " + t), o.label = 1;

                case 1:
                  return o.trys.push([1, 4, 5, 6]), [4, fetch$1(t)];

                case 2:
                  return [4, o.sent().json()];

                case 3:
                  return r = o.sent(), [3, 6];

                case 4:
                  return i = o.sent(), this._errors && this._errors.push(i), this._logs && this._logs.push("Fetch to " + t + " errored in " + (Date.now() - n) + "ms"), [2];

                case 5:
                  return Builder.isBrowser || (console.timeEnd("Fetch " + t), this._logs && this._logs.push("Fetched " + t + " in " + (Date.now() - n) + "ms")), [7];

                case 6:
                  return r && (Builder.isIframe && (fetchCache[t] = r), this.updateState(function (t) {
                    t[e] = r;
                  })), [2, r];
              }
            });
          });
        }, (r = this._asyncRequests && this._asyncRequests.find(function (e) {
          return isRequestInfo(e) && e.url === t;
        })) ? ((i = r.promise).then(function (t) {
          t && s.updateState(function (n) {
            n[e] = t;
          });
        }), [2, i]) : (o = n(), Builder.nextTick(function () {
          s._asyncRequests && s._asyncRequests.push(o);
        }), [2, o]));
      });
    });
  }, t.prototype.unsubscribe = function () {
    this.subscriptions && (this.subscriptions.unsubscribe(), this.subscriptions = new Subscription());
  }, t.prototype.handleBuilderRequest = function (e, t) {
    var n = this,
        r = tryEval(t, this.data, this._errors);
    this.subscriptions && this.unsubscribe(), r && this.subscriptions.add(this.builder.queueGetContent(r.model, r).subscribe(function (t) {
      t && n.updateState(function (n) {
        n[e] = t;
      });
    }));
  }, __decorate([debounceNextTick, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], t.prototype, "notifyStateChange", null), __decorate([Throttle(100, {
    leading: !0,
    trailing: !0
  }), __metadata("design:type", Function), __metadata("design:paramtypes", [String, String]), __metadata("design:returntype", void 0)], t.prototype, "throttledHandleRequest", null), t;
}(React.Component),
    BuilderSimpleComponent = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.state = {
      data: null,
      classes: [],
      loading: !1,
      error: !1
    }, t.ref = null, t.previousName = "", t.subscriptions = [], t.trackedClick = !1, t.onClick = function (e) {
      if (builder.canTrack) {
        var n = t.state.data;
        n && (builder.trackInteraction(n.id, n.testVariationId || n.id, t.trackedClick, e.nativeEvent), t.trackedClick || (t.trackedClick = !0));
      }
    }, t;
  }

  return __extends(t, e), t.prototype.addClass = function (e) {
    -1 === this.state.classes.indexOf(e) && this.setState(_assign(_assign({}, this.state), {
      classes: this.state.classes.concat([e])
    }));
  }, t.prototype.removeClass = function (e) {
    var t = this.state.classes.indexOf(e);

    if (-1 !== t) {
      var n = this.state.classes.slice();
      n.splice(t, 1), this.setState(_assign(_assign({}, this.state), {
        classes: n
      }));
    }
  }, t.prototype.componentWillUnmount = function () {
    this.unsubscribe();
  }, t.prototype.componentDidMount = function () {
    this.getContent();
  }, t.prototype.disconnectedCallback = function () {
    this.unsubscribe();
  }, t.prototype.componentWillUpdate = function (e) {
    e.name === this.props.name && e.entry === this.props.entry || this.getContent();
  }, t.prototype.loaded = function () {
    this.addClass("builder-loaded");
  }, t.prototype.getContent = function () {
    var e = this,
        t = this.props.apiKey;

    if (t && t !== builder.apiKey && (builder.apiKey = t), !builder.apiKey) {
      var n = builder.apiKey$.subscribe(function (t) {
        t && e.getContent();
      });
      this.subscriptions.push(function () {
        return n.unsubscribe();
      });
    }

    if (!this.props.html) {
      var r = this.props.name;
      if (r === this.previousName) return !1;
      var i = this.props.entry;
      if (this.unsubscribe(), !r) return !1;
      this.previousName = r, this.addClass("builder-loading"), this.setState(_assign(_assign({}, this.state), {
        loading: !0
      }));
      var o = builder.get(r, _assign({
        prerender: !0,
        entry: i || void 0,
        key: Builder.isEditing ? void 0 : i
      }, this.props.options)).subscribe(function (t) {
        e.removeClass("builder-loading"), e.loaded(), e.addClass("builder-no-content-found"), t ? e.ref && e.ref.classList.contains("builder-editor-injected") ? e.unsubscribe() : (e.setState(_assign(_assign({}, e.state), {
          data: t,
          loading: !1
        })), builder.canTrack && builder.trackImpression(t.id, t.testVariationId || t.id), t.data && t.data.html && (e.props.onLoad && e.props.onLoad(t), t.data.animations && t.data.animations.length && Builder.nextTick(function () {
          Builder.animator.bindAnimations(t.data.animations);
        }))) : e.props.onLoad && e.props.onLoad(t);
      }, function (t) {
        e.addClass("builder-errored"), e.addClass("builder-loaded"), e.removeClass("builder-loading"), e.props.onError && e.props.onError(t), e.setState(_assign(_assign({}, e.state), {
          loading: !1,
          error: !0
        }));
      });
      this.subscriptions.push(function () {
        return o.unsubscribe();
      });
    }
  }, t.prototype.unsubscribe = function () {
    this.subscriptions && (this.subscriptions.forEach(function (e) {
      return e();
    }), this.subscriptions = []);
  }, t.prototype.render = function () {
    var e = this,
        t = this.props.html || this.state && this.state.data && this.state.data.data && this.state.data.data.html;
    return React.createElement("div", {
      "builder-model": this.props.name,
      ref: function ref(t) {
        return e.ref = t;
      },
      className: this.state.classes.join(" "),
      dangerouslySetInnerHTML: t ? {
        __html: t
      } : void 0
    }, !t && this.state.loading && this.props.children || void 0);
  }, t;
}(React.Component);

function BuilderBlock$1(e) {
  return e.type = "react", Builder.Component(e);
}

function updateMetadata(e, t) {
  var n = Builder.components.find(function (t) {
    return "string" == typeof e ? t.name === e : t["class"] === t;
  }) || null,
      r = t(n);
  n && r ? Builder.registerComponent(r["class"] || n["class"], r) : n && !r || !n && r && Builder.registerComponent(r["class"], r);
}

function withBuilder(e, t) {
  return BuilderBlock$1(t)(e), e;
}

var withChildren = function withChildren(e) {
  var t = React.forwardRef(function (t, n) {
    var r = t.children || t.builderBlock && t.builderBlock.children && t.builderBlock.children.map(function (e) {
      return React.createElement(BuilderBlock, {
        key: e.id,
        block: e
      });
    });
    return React.createElement(e, _assign({}, t, {
      ref: n
    }), r);
  });
  return t.builderOptions = {
    canHaveChildren: !0
  }, t;
},
    noWrap = function noWrap(e) {
  var t = React.forwardRef(function (t, n) {
    var r = _assign(_assign({}, t), t.attributes);

    return React.createElement(e, _assign({}, r, {
      ref: n
    }));
  });
  return t.builderOptions = {
    noWrap: !0
  }, t;
},
    iconUrl = "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-text_fields-24px%20(1).svg?alt=media&token=12177b73-0ee3-42ca-98c6-0dd003de1929",
    TextComponent = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.textRef = null, t;
  }

  return __extends(t, e), t.prototype.componentDidUpdate = function (e) {
    this.allowTextEdit && (!this.textRef || "true" === this.textRef.contentEditable && this.textRef === document.activeElement || this.props.text !== e.text && (this.textRef.innerHTML = this.props.text));
  }, t.prototype.componentDidMount = function () {
    this.textRef && (this.textRef.innerHTML = this.props.text);
  }, Object.defineProperty(t.prototype, "allowTextEdit", {
    get: function get() {
      return Builder.isBrowser && Builder.isEditing && location.search.includes("builder.allowTextEdit=true") && !(this.props.builderBlock && this.props.builderBlock.bindings && (this.props.builderBlock.bindings["component.options.text"] || this.props.builderBlock.bindings["options.text"] || this.props.builderBlock.bindings.text));
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.render = function () {
    var e = this,
        t = this.allowTextEdit,
        n = {
      outline: "none",
      "& p:first-of-type, & .builder-paragraph:first-of-type": {
        margin: 0
      },
      "& > p, & .builder-paragraph": {
        color: "inherit",
        lineHeight: "inherit",
        letterSpacing: "inherit",
        fontWeight: "inherit",
        fontSize: "inherit",
        textAlign: "inherit",
        fontFamily: "inherit"
      }
    };
    return jsx(BuilderStoreContext.Consumer, null, function (r) {
      var i;
      return (null === (i = r.content.meta) || void 0 === i ? void 0 : i.rtlMode) && (n.direction = "rtl"), jsx(React.Fragment, null, jsx("span", _assign({
        ref: function ref(t) {
          e.textRef = t;
        },
        contentEditable: t || void 0,
        onInput: function onInput(n) {
          var r;
          t && (null === (r = window.parent) || void 0 === r || r.postMessage({
            type: "builder.textEdited",
            data: {
              id: e.props.builderBlock && e.props.builderBlock.id,
              value: n.currentTarget.innerHTML
            }
          }, "*"));
        },
        onKeyDown: function onKeyDown(n) {
          t && e.textRef && 27 === n.which && document.activeElement === e.textRef && e.textRef.blur();
        },
        onFocus: function onFocus(n) {
          var r;
          t && (null === (r = window.parent) || void 0 === r || r.postMessage({
            type: "builder.textFocused",
            data: {
              id: e.props.builderBlock && e.props.builderBlock.id
            }
          }, "*"));
        },
        onBlur: function onBlur(n) {
          var r;
          t && (null === (r = window.parent) || void 0 === r || r.postMessage({
            type: "builder.textBlurred",
            data: {
              id: e.props.builderBlock && e.props.builderBlock.id
            }
          }, "*"));
        },
        css: n,
        className: "builder-text"
      }, !t && {
        dangerouslySetInnerHTML: {
          __html: e.props.text || e.props.content || ""
        }
      })));
    });
  }, t;
}(React.Component),
    Text = withBuilder(TextComponent, {
  name: "Text",
  "static": !0,
  image: iconUrl,
  inputs: [{
    name: "text",
    type: "html",
    required: !0,
    autoFocus: !0,
    defaultValue: "Enter some text..."
  }],
  defaultStyles: {
    lineHeight: "normal",
    height: "auto",
    textAlign: "center"
  }
}),
    FragmentComponent = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return __extends(t, e), t.prototype.render = function () {
    return this.props.builderBlock && this.props.builderBlock.children && this.props.builderBlock.children.map(function (e, t) {
      return React.createElement(BuilderBlock, {
        block: e,
        key: e.id,
        index: t
      });
    });
  }, t;
}(React.Component),
    Fragment = withBuilder(FragmentComponent, {
  name: "Core:Fragment",
  canHaveChildren: !0,
  noWrap: !0,
  "static": !0,
  hideFromInsertMenu: !0
}),
    DEFAULT_ASPECT_RATIO = .7004048582995948,
    defaultBlocks = [{
  "@type": "@builder.io/sdk:Element",
  responsiveStyles: {
    large: {
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      flexShrink: "0",
      position: "relative",
      marginTop: "30px",
      textAlign: "center",
      lineHeight: "normal",
      height: "auto"
    }
  },
  component: {
    name: "Image",
    options: {
      image: "https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
      backgroundPosition: "center",
      backgroundSize: "cover",
      aspectRatio: DEFAULT_ASPECT_RATIO
    }
  }
}, {
  "@type": "@builder.io/sdk:Element",
  responsiveStyles: {
    large: {
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      flexShrink: "0",
      position: "relative",
      marginTop: "30px",
      textAlign: "center",
      lineHeight: "normal",
      height: "auto"
    }
  },
  component: {
    name: "Text",
    options: {
      text: "<p>Enter some text...</p>"
    }
  }
}],
    ColumnsComponent = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return __extends(t, e), Object.defineProperty(t.prototype, "columns", {
    get: function get() {
      return this.props.columns || [];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t.prototype, "gutterSize", {
    get: function get() {
      return "number" == typeof this.props.space ? this.props.space || 0 : 20;
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.getWidth = function (e) {
    return this.columns[e] && this.columns[e].width || 100 / this.columns.length;
  }, t.prototype.getColumnWidth = function (e) {
    var t = this.columns,
        n = this.gutterSize * (t.length - 1) / t.length;
    return "calc(" + this.getWidth(e) + "% - " + n + "px)";
  }, t.prototype.render = function () {
    var e,
        t = this,
        n = this.columns,
        r = this.gutterSize;
    return jsx(React.Fragment, null, jsx("div", {
      className: "builder-columns",
      css: _assign({
        display: "flex"
      }, "never" !== this.props.stackColumnsAt && (e = {}, e["@media (max-width: " + ("tablet" !== this.props.stackColumnsAt ? 639 : 999) + "px)"] = {
        flexDirection: this.props.reverseColumnsWhenStacked ? "column-reverse" : "column",
        alignItems: "stretch"
      }, e))
    }, n.map(function (e, n) {
      var i,
          o,
          s = e.link ? Link : "div";
      return jsx(React.Fragment, {
        key: n
      }, jsx(s, _assign({
        className: "builder-column"
      }, e.link ? {
        href: e.link
      } : null, {
        css: _assign((i = {
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          lineHeight: "normal"
        }, i["& > .builder-blocks"] = {
          flexGrow: 1
        }, i.width = t.getColumnWidth(n), i.marginLeft = 0 === n ? 0 : r, i), "never" !== t.props.stackColumnsAt && (o = {}, o["@media (max-width: " + ("tablet" !== t.props.stackColumnsAt ? 639 : 999) + "px)"] = {
          width: "100%",
          marginLeft: 0
        }, o))
      }), jsx(BuilderBlocks, {
        key: n,
        child: !0,
        parentElementId: t.props.builderBlock && t.props.builderBlock.id,
        blocks: e.blocks,
        dataPath: "component.options.columns." + n + ".blocks"
      })));
    })));
  }, t;
}(React.Component),
    Columns = withBuilder(ColumnsComponent, {
  name: "Columns",
  "static": !0,
  inputs: [{
    name: "columns",
    type: "array",
    subFields: [{
      name: "blocks",
      type: "array",
      hideFromUI: !0,
      defaultValue: defaultBlocks
    }, {
      name: "width",
      type: "number",
      hideFromUI: !0,
      helperText: "Width %, e.g. set to 50 to fill half of the space"
    }, {
      name: "link",
      type: "string",
      helperText: "Optionally set a url that clicking this column will link to"
    }],
    defaultValue: [{
      blocks: defaultBlocks
    }, {
      blocks: defaultBlocks
    }],
    onChange: function onChange(e) {
      function t() {
        n.forEach(function (e) {
          e["delete"]("width");
        });
      }

      var n = e.get("columns");
      Array.isArray(n) && (!n.find(function (e) {
        return e.get("width");
      }) || (n.find(function (e) {
        return !e.get("width");
      }) || 100 !== n.reduce(function (e, t) {
        return e + t.get("width");
      }, 0)) && t());
    }
  }, {
    name: "space",
    type: "number",
    defaultValue: 20,
    helperText: "Size of gap between columns",
    advanced: !0
  }, {
    name: "stackColumnsAt",
    type: "string",
    defaultValue: "tablet",
    helperText: "Convert horizontal columns to vertical at what device size",
    "enum": ["tablet", "mobile", "never"],
    advanced: !0
  }, {
    name: "reverseColumnsWhenStacked",
    type: "boolean",
    defaultValue: !1,
    helperText: "When stacking columns for mobile devices, reverse the ordering",
    advanced: !0
  }]
}),
    EmbedComponent = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.elementRef = null, t.scriptsInserted = new Set(), t.scriptsRun = new Set(), t;
  }

  return __extends(t, e), t.prototype.componentDidUpdate = function (e) {
    this.props.content !== e.content && this.findAndRunScripts();
  }, t.prototype.componentDidMount = function () {
    this.findAndRunScripts();
  }, t.prototype.findAndRunScripts = function () {
    if (this.elementRef && "undefined" != typeof window) for (var e = this.elementRef.getElementsByTagName("script"), t = 0; t < e.length; t++) {
      var n = e[t];

      if (n.src) {
        if (this.scriptsInserted.has(n.src)) continue;
        this.scriptsInserted.add(n.src);
        var r = document.createElement("script");
        r.async = !0, r.src = n.src, document.head.appendChild(r);
      } else {
        if (this.scriptsRun.has(n.innerText)) continue;
        this.scriptsRun.add(n.innerText);

        try {
          new Function(n.innerText)();
        } catch (e) {
          console.warn("Builder custom code component error:", e);
        }
      }
    }
  }, Object.defineProperty(t.prototype, "content", {
    get: function get() {
      return Builder.isServer ? (this.props.content || "").replace(/<script[\s\S]*?<\/script>/g, "") : this.props.content;
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.render = function () {
    var e = this;
    return React.createElement("div", {
      ref: function ref(t) {
        return e.elementRef = t;
      },
      className: "builder-embed",
      dangerouslySetInnerHTML: {
        __html: this.content
      }
    });
  }, t;
}(React.Component),
    Embed = withBuilder(EmbedComponent, {
  name: "Embed",
  "static": !0,
  inputs: [{
    name: "url",
    type: "url",
    required: !0,
    defaultValue: "",
    helperText: "e.g. enter a youtube url, google map, etc",
    onChange: function onChange(e) {
      var t = e.get("url");

      if (t) {
        e.set("content", "Loading...");
        return fetch("https://iframe.ly/api/iframely?url=" + t + "&api_key=ae0e60e78201a3f2b0de4b").then(function (e) {
          return e.json();
        }).then(function (n) {
          e.get("url") === t && (n.html ? e.set("content", n.html) : e.set("content", "Invalid url, please try another"));
        })["catch"](function (t) {
          e.set("content", "There was an error embedding this URL, please try again or another URL");
        });
      }

      e["delete"]("content");
    }
  }, {
    name: "content",
    type: "html",
    defaultValue: '<div style="padding: 20px; text-align: center">(Choose an embed URL)<div>',
    hideFromUI: !0
  }]
}),
    globalReplaceNodes = {} || null;

if (Builder.isBrowser && globalReplaceNodes) try {
  Array.from(document.querySelectorAll("heybloomwell.com" === location.host || "superkin.com" === location.host ? ".builder-custom-code" : ".builder-custom-code.replace-nodes")).forEach(function (e) {
    var t = e.parentElement,
        n = t && t.getAttribute("builder-id");
    n && (globalReplaceNodes[n] = e, e.remove());
  });
} catch (e) {
  console.error("Builder replace nodes error:", e);
}

var CustomCodeComponent = function (e) {
  function t(t) {
    var n,
        r = e.call(this, t) || this;

    if (r.elementRef = null, r.originalRef = null, r.scriptsInserted = new Set(), r.scriptsRun = new Set(), r.firstLoad = !0, r.replaceNodes = Builder.isBrowser && (t.replaceNodes || "heybloomwell.com" === location.host || "superkin.com" === location.host), r.replaceNodes && Builder.isBrowser && r.firstLoad && r.props.builderBlock) {
      var i = r.props.builderBlock.id;

      if (i && (null === (n = globalReplaceNodes) || void 0 === n ? void 0 : n[i])) {
        var o = globalReplaceNodes[i];
        r.originalRef = o, delete globalReplaceNodes[i];
      } else {
        var s = document.querySelectorAll("." + r.props.builderBlock.id + " .builder-custom-code");

        if (1 === s.length) {
          var a = s[0];
          r.originalRef = a, r.originalRef.remove();
        }
      }
    }

    return r;
  }

  return __extends(t, e), t.prototype.componentDidUpdate = function (e) {
    this.props.code !== e.code && this.findAndRunScripts();
  }, t.prototype.componentDidMount = function () {
    this.firstLoad = !1, this.findAndRunScripts(), Builder.isBrowser && this.replaceNodes && this.originalRef && this.elementRef && this.elementRef.appendChild(this.originalRef);
  }, t.prototype.findAndRunScripts = function () {
    if (this.elementRef && "undefined" != typeof window) for (var e = this.elementRef.getElementsByTagName("script"), t = 0; t < e.length; t++) {
      var n = e[t];

      if (n.src) {
        if (this.scriptsInserted.has(n.src)) continue;
        this.scriptsInserted.add(n.src);
        var r = document.createElement("script");
        r.async = !0, r.src = n.src, document.head.appendChild(r);
      } else {
        if (this.scriptsRun.has(n.innerText)) continue;

        try {
          this.scriptsRun.add(n.innerText), new Function(n.innerText)();
        } catch (e) {
          console.warn("Builder custom code component error:", e);
        }
      }
    }
  }, Object.defineProperty(t.prototype, "code", {
    get: function get() {
      return Builder.isServer && this.props.scriptsClientOnly ? (this.props.code || "").replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "") : this.props.code;
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.render = function () {
    var e = this;
    return React.createElement("div", _assign({
      ref: function ref(t) {
        return e.elementRef = t;
      },
      className: "builder-custom-code" + (this.props.replaceNodes ? " replace-nodes" : "")
    }, !this.replaceNodes && {
      dangerouslySetInnerHTML: {
        __html: this.code
      }
    }));
  }, t;
}(React.Component),
    CustomCode = withBuilder(CustomCodeComponent, {
  name: "Custom Code",
  "static": !0,
  inputs: [{
    name: "code",
    type: "html",
    required: !0,
    defaultValue: "<p>Hello there, I am custom HTML code!</p>",
    code: !0
  }, {
    name: "replaceNodes",
    type: "boolean",
    helperText: "Preserve server rendered dom nodes",
    defaultValue: !1,
    advanced: !0
  }, {
    name: "scriptsClientOnly",
    type: "boolean",
    defaultValue: !1,
    helperText: "Only print and run scripts on the client. Important when scripts influence DOM that could be replaced when client loads",
    advanced: !0
  }]
}),
    DEFAULT_ASPECT_RATIO$1 = .7041;

function updateQueryParam(e, t, n) {
  void 0 === e && (e = "");
  var r = new RegExp("([?&])" + t + "=.*?(&|$)", "i"),
      i = -1 !== e.indexOf("?") ? "&" : "?";
  return e.match(r) ? e.replace(r, "$1" + t + "=" + encodeURIComponent(n) + "$2") : e + i + t + "=" + encodeURIComponent(n);
}

var getSrcSet = function getSrcSet(e) {
  if (!e) return e;
  if (!e.match(/builder\.io/)) return e;
  return [100, 200, 400, 800, 1200, 1600, 2e3].map(function (t) {
    return updateQueryParam(e, "width", String(t)) + " " + t + "w";
  }).concat([e]).join(", ");
},
    ImageComponent = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.state = {
      imageLoaded: !t.useLazyLoading,
      load: !t.useLazyLoading
    }, t.pictureRef = null, t;
  }

  return __extends(t, e), Object.defineProperty(t.prototype, "useLazyLoading", {
    get: function get() {
      return (!Builder.isBrowser || !location.search.includes("builder.lazyLoadImages=false")) && (!(!Builder.isBrowser || !location.href.includes("builder.lazyLoadImages=true")) || this.props.lazy);
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.componentDidMount = function () {
    var e = this;

    if (this.props.lazy && Builder.isBrowser) {
      var t = throttle(function (n) {
        if (e.pictureRef) {
          var r = e.pictureRef.getBoundingClientRect(),
              i = window.innerHeight / 2;
          r.top < window.innerHeight + i && (e.setState(_assign(_assign({}, e.state), {
            load: !0
          })), window.removeEventListener("scroll", t));
        }
      }, 400, {
        leading: !1,
        trailing: !0
      });
      window.addEventListener("scroll", t, {
        capture: !0,
        passive: !0
      }), t();
    }
  }, t.prototype.getSrcSet = function () {
    var e = this.props.image;
    if (e && e.match(/builder\.io/)) return getSrcSet(e);
  }, t.prototype.render = function () {
    var e = this,
        t = this.props,
        n = t.aspectRatio,
        r = t.lazy,
        i = this.props.builderBlock && this.props.builderBlock.children,
        o = this.props.srcset,
        s = this.props.image;
    return o && s && s.includes("builder.io/api/v1/image") ? o.includes(s.split("?")[0]) || (console.debug("Removed given srcset"), o = this.getSrcSet()) : s && !o && (o = this.getSrcSet()), jsx(BuilderMetaContext.Consumer, null, function (t) {
      var s,
          a = t.ampMode,
          l = a ? "amp-img" : "img",
          u = (!r || e.state.load) && jsx(l, _assign({}, a ? {
        layout: "responsive",
        height: e.props.height || (n ? Math.round(1e3 * n) : void 0),
        width: e.props.width || (n ? Math.round(1e3 / n) : void 0)
      } : null, {
        alt: e.props.altText,
        key: Builder.isEditing && "string" == typeof e.props.image && e.props.image.split("?")[0] || void 0,
        role: e.props.altText ? void 0 : "presentation",
        css: _assign(_assign({
          opacity: a ? 1 : e.useLazyLoading && !e.state.imageLoaded ? 0 : 1,
          transition: "opacity 0.2s ease-in-out",
          objectFit: e.props.backgroundSize || "cover",
          objectPosition: e.props.backgroundPosition || "center"
        }, n && {
          position: "absolute",
          height: "100%",
          width: "100%",
          left: 0,
          top: 0
        }), a && (s = {}, s["& img"] = {
          objectFit: e.props.backgroundSize,
          ObjectPosition: e.props.backgroundPosition
        }, s)),
        className: "builder-image" + (e.props.className ? " " + e.props.className : ""),
        src: e.props.image
      }, !a && {
        onLoad: function onLoad() {
          return e.setState({
            imageLoaded: !0
          });
        }
      }, {
        srcSet: o,
        sizes: e.props.sizes
      }));
      return jsx(React.Fragment, null, a ? u : jsx("picture", {
        ref: function ref(t) {
          return e.pictureRef = t;
        }
      }, o && o.match(/builder\.io/) && jsx("source", {
        srcSet: o.replace(/\?/g, "?format=webp&"),
        type: "image/webp"
      }), u), n ? jsx("div", {
        className: "builder-image-sizer",
        css: {
          width: "100%",
          paddingTop: 100 * n + "%",
          pointerEvents: "none",
          fontSize: 0
        }
      }, " ") : null, i && i.length ? jsx("div", {
        css: {
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%"
        }
      }, i.map(function (e, t) {
        return jsx(BuilderBlock, {
          key: e.id,
          block: e
        });
      })) : null);
    });
  }, t;
}(React.Component),
    Image = withBuilder(ImageComponent, {
  name: "Image",
  "static": !0,
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4",
  defaultStyles: {
    minHeight: "20px",
    minWidth: "20px",
    overflow: "hidden"
  },
  canHaveChildren: !0,
  inputs: [{
    name: "image",
    type: "file",
    allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
    required: !0,
    defaultValue: "https://cdn.builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
    onChange: function onChange(e) {
      e["delete"]("srcset");
      var t,
          n,
          r = e.get("image"),
          i = e.get("aspectRatio");
      if (r && (!i || .7041 === i)) return (t = r, void 0 === n && (n = 6e4), new Promise(function (e, r) {
        var i = document.createElement("img"),
            o = !1;
        i.onload = function () {
          o = !0, e(i);
        }, i.addEventListener("error", function (e) {
          console.warn("Image load failed", e.error), r(e.error);
        }), i.src = t, setTimeout(function () {
          o || r(new Error("Image load timed out"));
        }, n);
      })).then(function (t) {
        var n,
            i = e.get("aspectRatio");
        e.get("image") !== r || i && .7041 !== i || t.width && t.height && (e.set("aspectRatio", (n = t.height / t.width, Math.round(1e3 * n) / 1e3)), e.set("height", t.height), e.set("width", t.width));
      });
    }
  }, {
    name: "backgroundSize",
    type: "text",
    defaultValue: "cover",
    "enum": [{
      label: "contain",
      value: "contain",
      helperText: "The image should never get cropped"
    }, {
      label: "cover",
      value: "cover",
      helperText: "The image should fill it's box, cropping when needed"
    }]
  }, {
    name: "backgroundPosition",
    type: "text",
    defaultValue: "center",
    "enum": ["center", "top", "left", "right", "bottom", "top left", "top right", "bottom left", "bottom right"]
  }, {
    name: "altText",
    type: "string",
    helperText: "Text to display when the user has images off"
  }, {
    name: "height",
    type: "number",
    hideFromUI: !0
  }, {
    name: "width",
    type: "number",
    hideFromUI: !0
  }, {
    name: "sizes",
    type: "string",
    hideFromUI: !0
  }, {
    name: "srcset",
    type: "string",
    hideFromUI: !0
  }, {
    name: "lazy",
    type: "boolean",
    hideFromUI: !0
  }, {
    name: "aspectRatio",
    type: "number",
    helperText: "This is the ratio of height/width, e.g. set to 1.5 for a 300px wide and 200px tall photo. Set to 0 to not force the image to maintain it's aspect ratio",
    advanced: !0,
    defaultValue: DEFAULT_ASPECT_RATIO$1
  }]
}),
    DEFAULT_ASPECT_RATIO$2 = .7004048582995948,
    VideoComponent = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.video = null, t;
  }

  return __extends(t, e), t.prototype.updateVideo = function () {
    this.video && (this.video.setAttribute("muted", String(this.props.muted)), this.video.setAttribute("playsinline", String(this.props.playsInline)), this.video.setAttribute("autoplay", String(this.props.autoPlay)));
  }, t.prototype.componentDidUpdate = function () {
    this.updateVideo();
  }, t.prototype.componentDidMount = function () {
    this.updateVideo();
  }, t.prototype.render = function () {
    var e = this,
        t = this.props.aspectRatio;
    return jsx("div", {
      css: {
        position: "relative",
        fontSize: 0
      }
    }, jsx("video", {
      key: this.props.video || "no-src",
      poster: this.props.posterImage,
      ref: function ref(t) {
        return e.video = t;
      },
      autoPlay: this.props.autoPlay,
      muted: this.props.muted,
      controls: this.props.controls,
      loop: this.props.loop,
      className: "builder-video",
      css: _assign({
        width: "100%",
        height: "100%",
        objectFit: this.props.fit,
        objectPosition: this.props.position,
        borderRadius: 1
      }, t ? {
        position: "absolute"
      } : null)
    }, jsx("source", {
      type: "video/mp4",
      src: this.props.video
    })), t ? jsx("div", {
      css: {
        width: "100%",
        paddingTop: 100 * t + "%",
        pointerEvents: "none"
      }
    }) : null);
  }, t;
}(React.Component),
    Video = withBuilder(VideoComponent, {
  name: "Video",
  "static": !0,
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-videocam-24px%20(1).svg?alt=media&token=49a84e4a-b20e-4977-a650-047f986874bb",
  inputs: [{
    name: "video",
    type: "file",
    allowedFileTypes: ["mp4"],
    defaultValue: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/assets%2FKQlEmWDxA0coC3PK6UvkrjwkIGI2%2F28cb070609f546cdbe5efa20e931aa4b?alt=media&token=912e9551-7a7c-4dfb-86b6-3da1537d1a7f",
    required: !0,
    onChange: function onChange(e) {
      var t,
          n,
          r = e.get("image"),
          i = e.get("aspectRatio");
      if (r && (!i || .7004048582995948 === i)) return (t = r, void 0 === n && (n = 6e4), new Promise(function (e, r) {
        var i = document.createElement("img"),
            o = !1;
        i.onload = function () {
          o = !0, e(i);
        }, i.addEventListener("error", function (e) {
          console.warn("Image load failed", e.error), r(e.error);
        }), i.src = t, setTimeout(function () {
          o || r(new Error("Image load timed out"));
        }, n);
      })).then(function (t) {
        var n,
            i = e.get("aspectRatio");
        e.get("image") !== r || i && .7004048582995948 !== i || t.width && t.height && e.set("aspectRatio", (n = t.height / t.width, Math.round(1e3 * n) / 1e3));
      });
    }
  }, {
    name: "posterImage",
    type: "file",
    allowedFileTypes: ["jpeg", "png"],
    helperText: "Image to show before the video plays"
  }, {
    name: "autoPlay",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "controls",
    type: "boolean",
    defaultValue: !1
  }, {
    name: "muted",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "loop",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "playsInline",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "fit",
    type: "text",
    defaultValue: "cover",
    "enum": ["contain", "cover", "fill", "auto"]
  }, {
    name: "position",
    type: "text",
    defaultValue: "center",
    "enum": ["center", "top", "left", "right", "bottom", "top left", "top right", "bottom left", "bottom right"]
  }, {
    name: "height",
    type: "number",
    advanced: !0
  }, {
    name: "width",
    type: "number",
    advanced: !0
  }, {
    name: "aspectRatio",
    type: "number",
    advanced: !0,
    defaultValue: DEFAULT_ASPECT_RATIO$2
  }]
}),
    size$1 = function size$1(e) {
  return Object.keys(e).length;
},
    SymbolComponent = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.ref = null, t;
  }

  return __extends(t, e), Object.defineProperty(t.prototype, "placeholder", {
    get: function get() {
      return jsx("div", {
        css: {
          padding: 10
        }
      }, "Symbols let you reuse dynamic elements across your content. Please choose a model and entry for this symbol.");
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.shouldComponentUpdate = function (e) {
    return !Builder.isEditing || hash(e) !== hash(this.props);
  }, t.prototype.render = function () {
    var e = this,
        t = this.props.symbol,
        n = !1;
    t || (n = !0);
    var r = this.props.dataOnly ? NoWrap : this.props.builderBlock && this.props.builderBlock.tagName || "div",
        i = t || {},
        o = i.model,
        s = i.entry,
        a = i.data,
        l = i.content,
        u = i.inline,
        p = i.dynamic;
    o && (s || p) || u || (n = !0);
    var d = p ? void 0 : [o, s].join(":"),
        c = Builder.isEditing ? null : a && size$1(a) && hash(a);
    d && c && c.length < 300 && (d += ":" + c);
    var m = this.props.attributes || {};
    return jsx(BuilderStoreContext.Consumer, {
      key: (o || "no model") + ":" + (s || "no entry")
    }, function (i) {
      var u, p, c, h;
      return jsx(r, _assign({
        "data-model": o
      }, m, {
        className: (m["class"] || m.className || "") + " builder-symbol" + ((null === (u = t) || void 0 === u ? void 0 : u.inline) ? " builder-inline-symbol" : "") + ((null === (p = t) || void 0 === p ? void 0 : p.dynamic) ? " builder-dynamic-symbol" : "")
      }), n ? e.placeholder : jsx(BuilderPage, {
        ref: function ref(t) {
          return e.ref = t;
        },
        context: _assign({}, i.context),
        modelName: o,
        entry: s,
        data: a,
        inlineContent: null === (c = t) || void 0 === c ? void 0 : c.inline,
        content: l,
        options: {
          key: d
        },
        hydrate: null === (h = i.state) || void 0 === h ? void 0 : h._hydrate,
        builderBlock: e.props.builderBlock,
        dataOnly: e.props.dataOnly
      }, e.props.children));
    });
  }, t;
}(React.Component),
    Symbol$1 = withBuilder(SymbolComponent, {
  name: "Symbol",
  noWrap: !0,
  "static": !0,
  inputs: [{
    name: "symbol",
    type: "uiSymbol"
  }, {
    name: "dataOnly",
    helperText: "Make this a data symbol that doesn't display any UI",
    type: "boolean",
    defaultValue: !1,
    advanced: !0,
    hideFromUI: !0
  }]
}),
    ButtonComponent = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return __extends(t, e), t.prototype.render = function () {
    var e = this.props.link ? Link : "span";
    return React.createElement(e, _assign({
      href: this.props.link,
      target: this.props.openLinkInNewTab ? "_blank" : void 0
    }, this.props.attributes), this.props.text);
  }, t;
}(React.Component),
    Button = withBuilder(ButtonComponent, {
  name: "Core:Button",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F81a15681c3e74df09677dfc57a615b13",
  defaultStyles: {
    appearance: "none",
    paddingTop: "15px",
    paddingBottom: "15px",
    paddingLeft: "25px",
    paddingRight: "25px",
    backgroundColor: "#3898EC",
    color: "white",
    borderRadius: "4px",
    textAlign: "center",
    cursor: "pointer"
  },
  inputs: [{
    name: "text",
    type: "text",
    defaultValue: "Click me!"
  }, {
    name: "link",
    type: "url"
  }, {
    name: "openLinkInNewTab",
    type: "boolean",
    defaultValue: !1,
    friendlyName: "Open link in new tab"
  }],
  "static": !0,
  noWrap: !0
}),
    SectionComponent = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return __extends(t, e), t.prototype.render = function () {
    return jsx("div", {
      css: {
        width: "100%",
        alignSelf: "stretch",
        flexGrow: 1,
        boxSizing: "border-box",
        maxWidth: this.props.maxWidth,
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        marginLeft: "auto",
        marginRight: "auto"
      }
    }, this.props.builderBlock && this.props.builderBlock.children && this.props.builderBlock.children.map(function (e, t) {
      return jsx(BuilderBlock, {
        key: e.id,
        block: e
      });
    }));
  }, t;
}(React.Component),
    Section = withBuilder(SectionComponent, {
  name: "Core:Section",
  "static": !0,
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F682efef23ace49afac61748dd305c70a",
  inputs: [{
    name: "maxWidth",
    type: "number",
    defaultValue: 1200
  }],
  defaultStyles: {
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingTop: "50px",
    paddingBottom: "50px",
    marginTop: "0px",
    width: "100vw",
    marginLeft: "calc(50% - 50vw)"
  },
  canHaveChildren: !0,
  defaultChildren: [{
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        textAlign: "center"
      }
    },
    component: {
      name: "Text",
      options: {
        text: "<p><b>I am a section! My content keeps from getting too wide, so that it's easy to read even on big screens.</b></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur</p>"
      }
    }
  }]
}),
    StateProviderComponent = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return __extends(t, e), t.prototype.render = function () {
    var e = this;
    return React.createElement(BuilderStoreContext.Consumer, null, function (t) {
      return React.createElement(BuilderStoreContext.Provider, {
        value: _assign(_assign({}, t), {
          state: _assign(_assign({}, t.state), e.props.state)
        })
      }, e.props.builderBlock && e.props.builderBlock.children && e.props.builderBlock.children.map(function (e, t) {
        return React.createElement(BuilderBlock, {
          block: e,
          key: e.id,
          index: t,
          child: !0
        });
      }));
    });
  }, t;
}(React.Component),
    StateProvider = withBuilder(StateProviderComponent, {
  name: "Builder:StateProvider",
  canHaveChildren: !0,
  "static": !0,
  hideFromInsertMenu: !0
}),
    prefetched = new Set();

function searchToObject$1(e) {
  var t = (e.search || "").substring(1).split("&"),
      n = {};

  for (var r in t) {
    if ("" !== t[r]) {
      var i = t[r].split("=");
      n[decodeURIComponent(i[0])] = decodeURIComponent(i[1]);
    }
  }

  return n;
}

var RouterComponent = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.builder = builder, t.routed = !1, t.preloadQueue = 0, t.onPopState = function (e) {
      t.updateLocationState();
    }, t.onMouseOverOrTouchStart = function (e) {
      if (!(t.preloadQueue > 4) && !1 !== t.props.preloadOnHover) {
        var n = t.findHrefTarget(e);

        if (n) {
          var r = n.getAttribute("href");

          if (r) {
            if (!t.isRelative(r)) {
              var i = t.convertToRelative(r);
              if (!i) return;
              r = i;
            }

            if (!r.startsWith("#") && !prefetched.has(r)) {
              prefetched.add(r);
              var o = t.parseUrl(r);
              t.preloadQueue++;
              var s = builder.getUserAttributes();
              s.urlPath = o.pathname, s.queryString = o.search;
              var a = builder.get(t.model, {
                userAttributes: s,
                key: t.model + ":" + o.pathname + o.search
              }).subscribe(function () {
                t.preloadQueue--, a.unsubscribe();
              });
            }
          }
        }
      }
    }, t.onClick = function (e) {
      return __awaiter(t, void 0, void 0, function () {
        var t, n, r, i;
        return __generator(this, function (o) {
          if (!1 === this.props.handleRouting) return [2];
          if (0 !== e.button || e.ctrlKey || e.defaultPrevented || e.metaKey) return [2];
          if (!(t = this.findHrefTarget(e))) return [2];
          if (t.target && "_client" !== t.target) return [2];
          if (!(n = t.getAttribute("href"))) return [2];
          if (this.props.onRoute && (r = {
            url: n,
            anchorNode: t,
            preventDefault: function preventDefault() {
              this.defaultPrevented = !0;
            },
            defaultPrevented: !1
          }, this.props.onRoute(r), r.defaultPrevented)) return [2];

          if (!this.isRelative(n)) {
            if (!(i = this.convertToRelative(n))) return [2];
            n = i;
          }

          return n.startsWith("#") || (e.preventDefault(), this.route(n)), [2];
        });
      });
    }, t.privateState = null, t;
  }

  return __extends(t, e), t.prototype.route = function (e) {
    return this.routed = !0, window.history && window.history.pushState ? (history.pushState(null, "", e), this.updateLocationState(), !0) : (location.href = e, !1);
  }, t.prototype.updateLocationState = function () {
    this.privateState && this.privateState.update(function (e) {
      e.location = _assign(_assign({}, e.location), {
        pathname: location.pathname,
        search: location.search,
        path: location.pathname.split("/").slice(1),
        query: searchToObject$1(location)
      });
    });
  }, Object.defineProperty(t.prototype, "model", {
    get: function get() {
      return this.props.model || "page";
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.componentDidMount = function () {
    "undefined" != typeof document && (document.addEventListener("click", this.onClick), window.addEventListener("popstate", this.onPopState), document.addEventListener("mouseover", this.onMouseOverOrTouchStart), document.addEventListener("touchstart", this.onMouseOverOrTouchStart));
  }, t.prototype.componentWillUnmount = function () {
    "undefined" != typeof document && (document.removeEventListener("click", this.onClick), document.removeEventListener("mouseover", this.onMouseOverOrTouchStart), window.removeEventListener("popstate", this.onPopState), document.removeEventListener("touchstart", this.onMouseOverOrTouchStart));
  }, t.prototype.render = function () {
    var e = this,
        t = this.model;
    return jsx(BuilderStoreContext.Consumer, null, function (n) {
      e.privateState = n;
      var r = n.state && n.state.location && n.state.location.pathname + n.state.location.search;
      return jsx("div", {
        className: "builder-router",
        "data-model": t
      }, jsx("style", null, "\n                @keyframes builderLoadingSpinner {\n                  0% {\n                    transform: rotate(0deg);\n                  }\n                  100% {\n                    transform: rotate(360deg);\n                  }\n                }\n                /* TODO: overridable tag */\n                .builder-page-loading {\n                  -webkit-animation: builderLoadingSpinner 1s infinite linear;\n                  animation: builderLoadingSpinner 1s infinite linear;\n                  -webkit-transform: translateZ(0);\n                  transform: translateZ(0);\n                  border-radius: 50%;\n                  width: 36px;\n                  height: 36px;\n                  margin: 6px auto;\n                  position: relative;\n                  border: 1px solid transparent;\n                  border-left: 1px solid #808284;\n                }\n              "), jsx(BuilderPage, {
        key: r,
        data: e.props.data,
        content: e.routed ? void 0 : e.props.content,
        modelName: t,
        options: {
          key: Builder.isEditing ? void 0 : e.model + ":" + r
        }
      }, e.props.children || jsx("div", {
        css: {
          display: "flex"
        }
      }, jsx("div", {
        css: {
          margin: "40vh auto"
        },
        className: "builder-page-loading"
      }))));
    });
  }, t.prototype.findHrefTarget = function (e) {
    for (var t = e.target; t;) {
      if (t instanceof HTMLAnchorElement && t.getAttribute("href")) return t;
      if (t === e.currentTarget) break;
      t = t.parentElement;
    }

    return null;
  }, t.prototype.isRelative = function (e) {
    return !e.match(/^(\/\/|https?:\/\/)/i);
  }, t.prototype.parseUrl = function (e) {
    var t = document.createElement("a");
    return t.href = e, t;
  }, t.prototype.convertToRelative = function (e) {
    var t = this.parseUrl(location.href),
        n = this.parseUrl(e);

    if (t.host === n.host) {
      var r = n.pathname + (n.search ? n.search : "");
      return r.startsWith("#") ? null : r || "/";
    }

    return null;
  }, t;
}(React.Component),
    Router = withBuilder(RouterComponent, {
  name: "Core:Router",
  hideFromInsertMenu: !0,
  inputs: [{
    name: "model",
    type: "string",
    defaultValue: "page",
    advanced: !0
  }, {
    name: "handleRouting",
    type: "boolean",
    defaultValue: !0,
    advanced: !0
  }, {
    name: "preloadOnHover",
    type: "boolean",
    defaultValue: !0,
    advanced: !0
  }, {
    name: "onRoute",
    type: "function",
    advanced: !0
  }]
}),
    get = function get(e, t, n) {
  var r = String.prototype.split.call(t, /[,[\].]+?/).filter(Boolean).reduce(function (e, t) {
    return null != e ? e[t] : e;
  }, e);
  return void 0 === r || r === e ? n : r;
},
    FormComponent = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.ref = null, t.state = {
      state: "unsubmitted",
      respnoseData: null,
      formErrorMessage: ""
    }, t;
  }

  return __extends(t, e), Object.defineProperty(t.prototype, "submissionState", {
    get: function get() {
      return Builder.isEditing && this.props.previewState || this.state.state;
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.render = function () {
    var e = this;
    return jsx(BuilderStoreContext.Consumer, null, function (t) {
      return jsx(BuilderStoreContext.Provider, {
        value: _assign(_assign({}, t), {
          state: _assign(_assign({}, t.state), {
            formErrorMessage: e.state.formErrorMessage
          })
        })
      }, jsx("form", _assign({
        validate: e.props.validate,
        ref: function ref(t) {
          return e.ref = t;
        },
        action: !e.props.sendWithJs && e.props.action,
        method: e.props.method,
        name: e.props.name,
        onSubmit: function onSubmit(t) {
          if ("zapier" === e.props.sendSubmissionsTo) t.preventDefault();else if (e.props.sendWithJs) {
            if (!e.props.action && "email" !== e.props.sendSubmissionsTo) return void t.preventDefault();
            t.preventDefault();
            var n = t.currentTarget,
                r = e.props.customHeaders || {},
                i = void 0,
                o = new FormData(n),
                s = Array.from(t.currentTarget.querySelectorAll("input,select,textarea")).filter(function (e) {
              return !!e.name;
            }).map(function (e) {
              var t,
                  n = e.name;
              if (e instanceof HTMLInputElement) {
                if ("radio" === e.type) {
                  if (e.checked) return {
                    key: n,
                    value: t = e.name
                  };
                } else if ("checkbox" === e.type) t = e.checked;else if ("number" === e.type || "range" === e.type) {
                  var r = e.valueAsNumber;
                  isNaN(r) || (t = r);
                } else t = "file" === e.type ? e.files : e.value;
              } else t = e.value;
              return {
                key: n,
                value: t
              };
            }),
                a = e.props.contentType;
            if (Array.from(s).forEach(function (e) {
              var t = e.value;
              (t instanceof File || Array.isArray(t) && t[0] instanceof File || t instanceof FileList) && (a = "multipart/form-data");
            }), "application/json" !== a) i = o;else {
              var l = {};
              Array.from(s).forEach(function (e) {
                var t = e.value,
                    n = e.key;
                set(l, n, t);
              }), i = JSON.stringify(l);
            }
            a && "multipart/form-data" !== a && (r["content-type"] = a);
            var u = new CustomEvent("presubmit", {
              detail: {
                body: i
              }
            });
            if (e.ref && (e.ref.dispatchEvent(u), u.defaultPrevented)) return;
            e.setState(_assign(_assign({}, e.state), {
              state: "sending"
            })), fetch(e.props.action || "https://builder.io/api/v1/form-submit?apiKey=" + builder.apiKey + "&to=" + btoa(e.props.sendSubmissionsToEmail || "") + "&name=" + encodeURIComponent(e.props.name || ""), {
              body: i,
              headers: r,
              method: e.props.method || "post"
            }).then(function (t) {
              return __awaiter(e, void 0, void 0, function () {
                var e, n, r, i, o;
                return __generator(this, function (s) {
                  switch (s.label) {
                    case 0:
                      return (n = t.headers.get("content-type")) && -1 !== n.indexOf("application/json") ? [4, t.json()] : [3, 2];

                    case 1:
                      return e = s.sent(), [3, 4];

                    case 2:
                      return [4, t.text()];

                    case 3:
                      e = s.sent(), s.label = 4;

                    case 4:
                      if (!t.ok && this.props.errorMessagePath && (r = get(e, this.props.errorMessagePath)) && ("string" != typeof r && (r = JSON.stringify(r)), this.setState(_assign(_assign({}, this.state), {
                        formErrorMessage: r
                      }))), this.setState(_assign(_assign({}, this.state), {
                        responseData: e,
                        state: t.ok ? "success" : "error"
                      })), t.ok) {
                        if (i = new CustomEvent("submit:success", {
                          detail: {
                            res: t,
                            body: e
                          }
                        }), this.ref) {
                          if (this.ref.dispatchEvent(i), i.defaultPrevented) return [2];
                          !1 !== this.props.resetFormOnSubmit && this.ref.reset();
                        }

                        this.props.successUrl && (this.ref ? (o = new CustomEvent("route", {
                          detail: {
                            url: this.props.successUrl
                          }
                        }), this.ref.dispatchEvent(o), o.defaultPrevented || (location.href = this.props.successUrl)) : location.href = this.props.successUrl);
                      }

                      return [2];
                  }
                });
              });
            }, function (t) {
              var n = new CustomEvent("submit:error", {
                detail: {
                  error: t
                }
              });
              e.ref && (e.ref.dispatchEvent(n), n.defaultPrevented) || e.setState(_assign(_assign({}, e.state), {
                responseData: t,
                state: "error"
              }));
            });
          }
        }
      }, e.props.attributes), e.props.builderBlock && e.props.builderBlock.children && e.props.builderBlock.children.map(function (e, t) {
        return jsx(BuilderBlock, {
          key: e.id,
          block: e
        });
      }), "error" === e.submissionState && jsx(BuilderBlocks, {
        dataPath: "errorMessage",
        blocks: e.props.errorMessage
      }), "sending" === e.submissionState && jsx(BuilderBlocks, {
        dataPath: "sendingMessage",
        blocks: e.props.sendingMessage
      }), "error" === e.submissionState && e.state.respnoseData && jsx("pre", {
        className: "builder-form-error-text",
        css: {
          padding: 10,
          color: "red",
          textAlign: "center"
        }
      }, JSON.stringify(e.state.respnoseData, null, 2)), "success" === e.submissionState && jsx(BuilderBlocks, {
        dataPath: "successMessage",
        blocks: e.props.successMessage
      })));
    });
  }, t;
}(React.Component),
    Form = withBuilder(FormComponent, {
  name: "Form:Form",
  defaults: {
    responsiveStyles: {
      large: {
        marginTop: "15px",
        paddingBottom: "15px"
      }
    }
  },
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fef36d2a846134910b64b88e6d18c5ca5",
  inputs: [{
    name: "sendSubmissionsTo",
    type: "string",
    "enum": [{
      label: "Send to email",
      value: "email",
      helperText: "Send form submissions to the email address of your choosing"
    }, {
      label: "Custom",
      value: "custom",
      helperText: "Handle where the form requests go manually with a little code, e.g. to your own custom backend"
    }],
    defaultValue: "email"
  }, {
    name: "sendSubmissionsToEmail",
    type: "string",
    required: !0,
    defaultValue: "your@email.com",
    showIf: 'options.get("sendSubmissionsTo") === "email"'
  }, {
    name: "sendWithJs",
    type: "boolean",
    helperText: "Set to false to use basic html form action",
    defaultValue: !0,
    showIf: 'options.get("sendSubmissionsTo") === "custom"'
  }, {
    name: "name",
    type: "string",
    defaultValue: "My form"
  }, {
    name: "action",
    type: "string",
    helperText: "URL to send the form data to",
    showIf: 'options.get("sendSubmissionsTo") === "custom"'
  }, {
    name: "contentType",
    type: "string",
    defaultValue: "application/json",
    advanced: !0,
    "enum": ["application/json", "multipart/form-data", "application/x-www-form-urlencoded"],
    showIf: 'options.get("sendSubmissionsTo") === "custom" && options.get("sendWithJs") === true'
  }, {
    name: "method",
    type: "string",
    showIf: 'options.get("sendSubmissionsTo") === "custom"',
    advanced: !0
  }, {
    name: "previewState",
    type: "string",
    "enum": ["unsubmitted", "sending", "success", "error"],
    defaultValue: "unsubmitted",
    helperText: 'Choose a state to edit, e.g. choose "success" to show what users see on success and edit the message',
    showIf: 'options.get("sendSubmissionsTo") !== "zapier" && options.get("sendWithJs") === true'
  }, {
    name: "successUrl",
    type: "url",
    helperText: "Optional URL to redirect the user to on form submission success",
    showIf: 'options.get("sendSubmissionsTo") !== "zapier" && options.get("sendWithJs") === true'
  }, {
    name: "resetFormOnSubmit",
    type: "boolean",
    showIf: function showIf(e) {
      return "custom" === e.get("sendSubmissionsTo") && !0 === e.get("sendWithJs");
    },
    advanced: !0
  }, {
    name: "successMessage",
    type: "uiBlocks",
    hideFromUI: !0,
    defaultValue: [{
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          marginTop: "10px"
        }
      },
      component: {
        name: "Text",
        options: {
          text: "<span>Thanks!</span>"
        }
      }
    }]
  }, {
    name: "validate",
    type: "boolean",
    defaultValue: !0,
    advanced: !0
  }, {
    name: "errorMessagePath",
    type: "text",
    advanced: !0,
    helperText: 'Path to where to get the error message from in a JSON response to display to the user, e.g. "error.message" for a response like { "error": { "message": "this username is taken" }}'
  }, {
    name: "errorMessage",
    type: "uiBlocks",
    hideFromUI: !0,
    defaultValue: [{
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          marginTop: "10px"
        }
      },
      bindings: {
        "component.options.text": "state.formErrorMessage || block.component.options.text"
      },
      component: {
        name: "Text",
        options: {
          text: "<span>Form submission error :( Please check your answers and try again</span>"
        }
      }
    }]
  }, {
    name: "sendingMessage",
    type: "uiBlocks",
    hideFromUI: !0,
    defaultValue: [{
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          marginTop: "10px"
        }
      },
      component: {
        name: "Text",
        options: {
          text: "<span>Sending...</span>"
        }
      }
    }]
  }, _assign(_assign({
    name: "customHeaders",
    type: "map"
  }, {
    valueType: {
      type: "string"
    }
  }), {
    advanced: !0,
    showIf: 'options.get("sendSubmissionsTo") === "custom" && options.get("sendWithJs") === true'
  })],
  noWrap: !0,
  canHaveChildren: !0,
  defaultChildren: [{
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Text",
      options: {
        text: "<span>Enter your name</span>"
      }
    }
  }, {
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Form:Input",
      options: {
        name: "name",
        placeholder: "Jane Doe"
      }
    }
  }, {
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Text",
      options: {
        text: "<span>Enter your email</span>"
      }
    }
  }, {
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Form:Input",
      options: {
        name: "email",
        placeholder: "jane@doe.com"
      }
    }
  }, {
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Form:SubmitButton",
      options: {
        text: "Submit"
      }
    }
  }]
}),
    FormInputComponent = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return __extends(t, e), t.prototype.render = function () {
    return React.createElement("input", _assign({
      key: Builder.isEditing && this.props.defaultValue ? this.props.defaultValue : "default-key",
      placeholder: this.props.placeholder,
      type: this.props.type,
      name: this.props.name,
      value: this.props.value,
      defaultValue: this.props.defaultValue,
      required: this.props.required
    }, this.props.attributes));
  }, t;
}(React.Component),
    FormInput = withBuilder(FormInputComponent, {
  name: "Form:Input",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fad6f37889d9e40bbbbc72cdb5875d6ca",
  inputs: [{
    name: "type",
    type: "text",
    "enum": ["text", "number", "email", "url", "checkbox", "radio", "range", "date", "datetime-local", "search", "tel", "time", "file", "month", "week", "password", "color", "hidden"],
    defaultValue: "text"
  }, {
    name: "name",
    type: "string",
    helperText: 'Every input in a form needs a unique name describing what it takes, e.g. "email"'
  }, {
    name: "placeholder",
    type: "string",
    defaultValue: "Hello there",
    helperText: "Text to display when there is no value"
  }, {
    name: "defaultValue",
    type: "string"
  }, {
    name: "value",
    type: "string",
    advanced: !0
  }, {
    name: "required",
    type: "boolean",
    helperText: "Is this input required to be filled out to submit a form",
    defaultValue: !1
  }],
  noWrap: !0,
  "static": !0,
  defaultStyles: {
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "10px",
    paddingRight: "10px",
    borderRadius: "3px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#ccc"
  }
}),
    FormSubmitButtonComponent = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return __extends(t, e), t.prototype.render = function () {
    return React.createElement("button", _assign({
      type: "submit"
    }, this.props.attributes), this.props.text);
  }, t;
}(React.Component),
    FormSubmitButton = withBuilder(FormSubmitButtonComponent, {
  name: "Form:SubmitButton",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fdf2820ffed1f4349a94c40b3221f5b98",
  defaultStyles: {
    appearance: "none",
    paddingTop: "15px",
    paddingBottom: "15px",
    paddingLeft: "25px",
    paddingRight: "25px",
    backgroundColor: "#3898EC",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer"
  },
  inputs: [{
    name: "text",
    type: "text",
    defaultValue: "Click me"
  }],
  "static": !0,
  noWrap: !0
}),
    LabelComponent = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return __extends(t, e), t.prototype.render = function () {
    return React.createElement("label", _assign({
      htmlFor: this.props["for"]
    }, this.props.attributes), this.props.text && React.createElement("span", {
      className: "builder-label-text",
      dangerouslySetInnerHTML: {
        __html: this.props.text
      }
    }), this.props.builderBlock && this.props.builderBlock.children && this.props.builderBlock.children.map(function (e) {
      return React.createElement(BuilderBlock, {
        key: e.id,
        block: e
      });
    }));
  }, t;
}(React.Component),
    Label = withBuilder(LabelComponent, {
  name: "Form:Label",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F9322342f04b545fb9a8091cd801dfb5b",
  inputs: [{
    name: "text",
    type: "html",
    richText: !0,
    defaultValue: "Label"
  }, {
    name: "for",
    type: "text",
    helperText: "The name of the input this label is for",
    advanced: !0
  }],
  noWrap: !0,
  "static": !0,
  canHaveChildren: !0
}),
    FormSelectComponent = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return __extends(t, e), t.prototype.render = function () {
    var e = this.props.options;
    return React.createElement("select", _assign({
      value: this.props.value,
      key: Builder.isEditing && this.props.defaultValue ? this.props.defaultValue : "default-key",
      defaultValue: this.props.defaultValue,
      name: this.props.name
    }, this.props.attributes), e && e.map(function (e) {
      return React.createElement("option", {
        value: e.value
      }, e.name || e.value);
    }));
  }, t;
}(React.Component),
    FormSelect = withBuilder(FormSelectComponent, {
  name: "Form:Select",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F83acca093fb24aaf94dee136e9a4b045",
  defaultStyles: {
    alignSelf: "flex-start"
  },
  inputs: [{
    name: "options",
    type: "list",
    required: !0,
    subFields: [{
      name: "value",
      type: "text",
      required: !0
    }, {
      name: "name",
      type: "text"
    }],
    defaultValue: [{
      value: "option 1"
    }, {
      value: "option 2"
    }]
  }, {
    name: "name",
    type: "string",
    helperText: 'Every select in a form needs a unique name descriptiong what it gets, e.g. "email"'
  }, {
    name: "defaultValue",
    type: "string"
  }, {
    name: "value",
    type: "string",
    advanced: !0
  }, {
    name: "required",
    type: "boolean",
    defaultValue: !1
  }],
  "static": !0,
  noWrap: !0
}),
    TextAreaComponent = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return __extends(t, e), t.prototype.render = function () {
    return React.createElement("textarea", _assign({
      placeholder: this.props.placeholder,
      name: this.props.name,
      value: this.props.value,
      defaultValue: this.props.defaultValue
    }, this.props.attributes));
  }, t;
}(React.Component),
    TextArea = withBuilder(TextAreaComponent, {
  name: "Form:TextArea",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Ff74a2f3de58c4c3e939204e5b6b8f6c3",
  inputs: [{
    advanced: !0,
    name: "value",
    type: "string"
  }, {
    name: "name",
    type: "string",
    helperText: 'Every input in a form needs a unique name descriptiong what it gets, e.g. "email"'
  }, {
    name: "defaultValue",
    type: "string"
  }, {
    name: "placeholder",
    type: "string",
    defaultValue: "Hello there"
  }, {
    name: "required",
    type: "boolean",
    defaultValue: !1
  }],
  defaultStyles: {
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "10px",
    paddingRight: "10px",
    borderRadius: "3px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#ccc"
  },
  "static": !0,
  noWrap: !0
}),
    ImgComponent = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return __extends(t, e), t.prototype.render = function () {
    var e = this.props.attributes || {};
    return React.createElement("img", _assign({}, this.props.attributes, {
      src: this.props.image || e.src
    }));
  }, t;
}(React.Component),
    Img = withBuilder(ImgComponent, {
  name: "Raw:Img",
  hideFromInsertMenu: !0,
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4",
  inputs: [{
    name: "image",
    type: "file",
    allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
    required: !0
  }],
  noWrap: !0,
  "static": !0
});

Builder.isReact = !0;
export default builder;
export { BuilderAsyncRequestsContext, BuilderBlock$1 as BuilderBlock, BuilderBlock as BuilderBlockComponent, BuilderBlocks, BuilderPage as BuilderComponent, BuilderContent, BuilderMetaContext, BuilderPage, BuilderSimpleComponent, BuilderStoreContext, Button, Columns, CustomCode, Embed, Form, FormInput, FormSelect, FormSubmitButton, Fragment, Image, Img, Label, Router, Section, StateProvider, Symbol$1 as Symbol, Text, TextArea, Video, getSrcSet, noWrap, onChange, stringToFunction, updateMetadata, withBuilder, withChildren };